{
  "account.account": "Profil og sikkerhed",
  "account.accountDeleted": "Din konto er blevet slettet.",
  "account.accountDescription": "Navn, adgangskode, sletning af konto",
  "account.accountSection": "Konto",
  "account.changeEmail": "Skift e-mail",
  "account.changePassword": "Skift adgangskode",
  "account.currentPassword": "Nuværende adgangskode",
  "account.dangerZone": "Farezone",
  "account.deleteAccount": "Slet din konto",
  "account.deleteAccountConfirmation": "Er du sikker på, at du vil slette din konto? Denne handling kan ikke fortrydes.",
  "account.deleteAccountDescription": "Denne handling sletter din konto og alle dine oplysninger. Der er ingen vej tilbage.",
  "account.emailChange": "Skift e-mailadresse",
  "account.emailChangeConfirmation": "Bekræftelse af e-mailændring",
  "account.emailChangeFailure": "Linket til e-mailændring er ugyldigt eller udløbet.",
  "account.emailChangeIntro": "Indtast din nye e-mailadresse og din nuværende adgangskode. Vi sender et link til den nye adresse: din e-mail ændres først, når du åbner det.",
  "account.emailChangeSuccess": "Din e-mail er blevet ændret til {newEmail}.",
  "account.emailChangeSuccessNoAddress": "Din e-mailadresse er blevet ændret.",
  "account.emailChangeVerificationSent": "En bekræftelses-e-mail er blevet sendt til din nye e-mailadresse. Tjek venligst din indbakke og klik på linket for at bekræfte ændringen.",
  "account.manageAccount": "Administrer konto",
  "account.newEmailAddress": "Ny e-mailadresse",
  "account.newPassword": "Ny adgangskode",
  "account.newPasswordAgain": "Ny adgangskode (gentag)",
  "account.oldPassword": "Nuværende adgangskode",
  "account.passwordChange": "Ændring af adgangskode",
  "account.passwordChangeDescription": "Hold din konto sikker",
  "account.passwordUpdated": "Adgangskoden blev opdateret.",
  "account.profile": "Profil",
  "account.profileUpdated": "Profil opdateret.",
  "account.signedInAs": "Logget ind som",
  "account.updateYourProfile": "Opdater din profil",
  "account.updateYourProfileDescription": "Navn og visningsindstillinger",
  "addons.accountOnHold": "Din kontoforbindelse er udløbet. Tilslut igen for at genoptage dataopdateringer.",
  "addons.accountOnHoldTitle": "Konto sat på pause",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Opret og hent din API nøgle via dette link",
  "addons.ambientWeatherDescription": "Ambient Weather-vejrstationer (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API-nøgle",
  "addons.applicationKey": "Applikationsnøgle",
  "addons.availableServices": "Tilgængelige",
  "addons.cannotDisconnectLastAccount": "Kan ikke afbryde din eneste loginmetode. Tilføj venligst en anden loginmetode først.",
  "addons.connect": "Tilslut",
  "addons.connected": "Tilsluttet",
  "addons.connectedAccounts": "Tilknyttede konti",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedServices": "Tilsluttet",
  "addons.connectedSince": "Tilsluttet siden {date}",
  "addons.connectionSection": "Forbindelse",
  "addons.connectionSuccess": "{provider}-konto tilsluttet",
  "addons.davisApiSecret": "API-hemmelighed",
  "addons.davisApiV2Key": "V2 API-nøgle",
  "addons.davisDescription": "Davis-vejrstationer (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Hent din V2 API nøgle fra dette link",
  "addons.disconnect": "Afbryd",
  "addons.disconnectConfirmation": "Er du sikker på, at du vil afbryde din {provider}-konto?",
  "addons.disconnectionSuccess": "{provider}-konto afbrudt",
  "addons.disconnectProviderDescription": "Stopper synkroniseringen. Din historik bevares.",
  "addons.ecowittCreateAndRetrieveKeys": "Opret og hent både en API-nøgle og en applikationsnøgle fra dette link",
  "addons.ecowittDescription": "Ecowitt leverer professionelle wifi vejrstationer, inde- og udetermometre, fugtighedsmålere, præcisions regnmålere, luftkvalitetsmålere og mere",
  "addons.helpLink": "Sådan forbinder du {provider}",
  "addons.integrationsSection": "Integrationer",
  "addons.myAcuriteAccountOnHold": "Din konto er blevet tilbageholdt. Indtast venligst din adgangskode for at oprette forbindelse til din konto igen",
  "addons.myAcuriteDescription": "AcuRite er det #1 vejrstationsmærke i Nordamerika. Som førende inden for tid, temperatur og vejrteknologi giver AcuRite dig detaljerede oplysninger om dit indendørs og udendørs miljø, så du kan planlægge din dag med tillid.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Brug din Netatmo-termostat til at ændre dit hjems temperatur, fra din seng eller fra den anden side af jorden",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Din personlige vejrstation derhjemme",
  "addons.notConnected": "Ikke tilsluttet",
  "addons.or": "eller",
  "addons.providerAccountDisconnected": "Forbindelsen til din vejrtjeneste er udløbet. Tilslut igen for at genoptage dataopdateringer.",
  "addons.reconnect": "Forbind igen",
  "addons.socialConnectionsIntro": "Tilknyt dine sociale konti for hurtig login. Du kan tilslutte eller afbryde konti når som helst.",
  "addons.weatherflowCreateToken": "Opret og hent dit token fra dette link",
  "addons.weatherflowTempestDescription": "Tempest Weather System med indbygget vind- og regnmåler",
  "addons.weatherServices": "Vejrtjenester",
  "addons.weatherServicesConnected": "{count, plural, =0 {Ingen tjenester tilsluttet} one {# tjeneste tilsluttet} other {# tjenester tilsluttet}}",
  "addons.weatherServicesDescription": "Forbind Netatmo, Davis, Weatherflow og mere",
  "addons.wundergroundApiKey": "API-nøgle",
  "addons.wundergroundDescription": "Weather Underground er et globalt fællesskab af mennesker, der forbinder data fra miljøsensorer som vejrstationer og luftkvalitetsmålere, så vi kan levere de rige, hyperlokale data, du har brug for til at dyrke dine passioner",
  "addons.wundergroundRetrieveApiKey": "Hent din API nøgle fra dette link",
  "addons.wundergroundStationId": "Stations-ID",
  "airQuality.adviceActivityGood": "En ideel dag til at være aktiv udendørs",
  "airQuality.adviceActivityHazardous": "Undgå al fysisk aktivitet udendørs",
  "airQuality.adviceActivityLabel": "Fysisk aktivitet",
  "airQuality.adviceActivityModerate": "En god dag til at være aktiv udendørs",
  "airQuality.adviceActivitySensitive": "Overvej kortere og mindre intense aktiviteter udendørs",
  "airQuality.adviceActivityUnhealthy": "Begræns lange eller intense aktiviteter, og hold flere pauser",
  "airQuality.adviceActivityVeryUnhealthy": "Undgå lange eller intense aktiviteter; overvej at flytte dem indendørs",
  "airQuality.adviceGroupsGood": "Ingen særlige forholdsregler nødvendige",
  "airQuality.adviceGroupsHazardous": "Bliv indendørs, og hold aktivitetsniveauet lavt",
  "airQuality.adviceGroupsLabel": "Følsomme grupper",
  "airQuality.adviceGroupsModerate": "Særligt følsomme personer: kortere og mindre intense aktiviteter",
  "airQuality.adviceGroupsSensitive": "Gør aktiviteter udendørs kortere og mindre intense, og hold flere pauser",
  "airQuality.adviceGroupsUnhealthy": "Undgå lange eller intense aktiviteter udendørs; overvej at flytte dem indendørs",
  "airQuality.adviceGroupsVeryUnhealthy": "Undgå al fysisk aktivitet udendørs; udskyd den eller flyt den indendørs",
  "airQuality.adviceTimingLabel": "Hvornår du bør gå ud",
  "airQuality.adviceTimingMorning": "Helst om formiddagen – der er ozonniveauet lavere",
  "airQuality.airQuality": "Luftkvalitet",
  "airQuality.airQualityIndex": "Luftkvalitetsindex",
  "airQuality.aqiForecast": "Prognose for luftkvalitet",
  "airQuality.co2Fresh": "Frisk",
  "airQuality.co2GettingStale": "Lidt tungt",
  "airQuality.co2Stale": "Tungt",
  "airQuality.dailyForecast": "Daglig prognose",
  "airQuality.dominantPollutant": "Dominerende forurenende stof",
  "airQuality.expectedPeak": "Forventet top",
  "airQuality.good": "God",
  "airQuality.goodDescription": "Luftkvaliteten anses for tilfredsstillende og risikoen for luftforurening er lille eller ikke eksisterende",
  "airQuality.hazardous": "Farlig",
  "airQuality.hazardousDescription": "Helbredsadvarsel: Alle kan opleve mere alvorlige helbredseffekter",
  "airQuality.indoorAirQuality": "Indendørs luftkvalitet",
  "airQuality.moderate": "Moderat",
  "airQuality.moderateDescription": "Luftkvaliteten er acceptabel. Men for visse typer af forureninger kan der findes et mindre helbredsproblem for et meget lille antal mennesker, som er overfølsomme over for luftforureninger",
  "airQuality.noForecastForLocation": "Der er ingen luftkvalitetsprognose for denne placering.",
  "airQuality.now": "Nu",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Forurenende stoffer",
  "airQuality.recommendations": "Anbefalinger",
  "airQuality.sensitiveUnhealthy": "Usund for følsomme grupper",
  "airQuality.sensitiveUnhealthyDescription": "Følsomme personer kan opleve helbredsproblemer. Normale mennesker vil intet mærke",
  "airQuality.subIndex": "AQI-delindeks",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Forstå indekset",
  "airQuality.unhealthy": "Usund",
  "airQuality.unhealthyDescription": "Alle kan opleve helbredseffekter, især følsomme personer",
  "airQuality.veryUnhealthy": "Meget usund",
  "airQuality.veryUnhealthyDescription": "Advarsler om nødsituationer. Det er sandsynligt at hele befolkningen påvirkes",
  "alerts.addAlert": "Tilføj advarsel",
  "alerts.addCondition": "Tilføj betingelse",
  "alerts.alertAdded": "Advarsel tilføjet",
  "alerts.alertAuthorizationNotice": "Advarsler virker kun hvis SmartMixin har tilladelse til at vise notifikationer",
  "alerts.alertDeleted": "Advarsel slettet",
  "alerts.alertName": "Advarselsnavn",
  "alerts.alertWhen": "Jeg vil advares når",
  "alerts.aqiGreaterThan": "AQI over",
  "alerts.aqiGreaterThanThreshold": "AQI over {value}{unit}",
  "alerts.aqiLessThan": "AQI under",
  "alerts.aqiLessThanThreshold": "AQI under {value}{unit}",
  "alerts.atLeastOneCondition": "Der skal tilføjes mindst én betingelse",
  "alerts.co2GreaterThan": "CO2 over",
  "alerts.co2GreaterThanThreshold": "CO2 over {value}{unit}",
  "alerts.co2LessThan": "CO2 under",
  "alerts.co2LessThanThreshold": "CO2 under {value}{unit}",
  "alerts.conditions": "Betingelser",
  "alerts.conditionsDroppedOnStationChange": "Understøttes ikke af denne station og er fjernet: {conditions}",
  "alerts.createAlert": "Opret advarsel",
  "alerts.dailyPrecipitationGreaterThan": "Daglig nedbør større end",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Daglig nedbør over grænsen på {value}{unit}",
  "alerts.deleteAlert": "Slet advarsel",
  "alerts.editAlert": "Rediger advarsel",
  "alerts.editCondition": "Rediger betingelse",
  "alerts.gustSpeedGreaterThan": "Vindstød over",
  "alerts.gustSpeedGreaterThanThreshold": "Vindstød over {value}{unit}",
  "alerts.gustSpeedLessThan": "Vindstød under",
  "alerts.gustSpeedLessThanThreshold": "Vindstød under {value}{unit}",
  "alerts.heatIndexGreaterThan": "Varmeindeks over",
  "alerts.heatIndexGreaterThanThreshold": "Varmeindeks over {value}{unit}",
  "alerts.heatIndexLessThan": "Varmeindeks under",
  "alerts.heatIndexLessThanThreshold": "Varmeindeks under {value}{unit}",
  "alerts.humidexGreaterThan": "Luftfugtighedsindeks over",
  "alerts.humidexGreaterThanThreshold": "Luftfugtighedsindeks over {value}{unit}",
  "alerts.humidexLessThan": "Luftfugtighedsindeks under",
  "alerts.humidexLessThanThreshold": "Luftfugtighedsindeks under {value}{unit}",
  "alerts.humidityGreaterThan": "Fugtighed over",
  "alerts.humidityGreaterThanThreshold": "Fugtighed over {value}{unit}",
  "alerts.humidityLessThan": "Fugtighed under",
  "alerts.humidityLessThanThreshold": "Fugtighed under {value}{unit}",
  "alerts.inProgress": "Advarsel, betingelse(r) opfyldt",
  "alerts.leafWetnessGreaterThan": "Bladfugt over",
  "alerts.leafWetnessGreaterThanThreshold": "Bladfugt over {value}{unit}",
  "alerts.leafWetnessLessThan": "Bladfugt under",
  "alerts.leafWetnessLessThanThreshold": "Bladfugt under {value}{unit}",
  "alerts.myAlerts": "Mine advarsler",
  "alerts.noConfiguredAlert": "Du har ikke oprettet nogen advarsler endnu, start med at tilføje en",
  "alerts.noiseGreaterThan": "Støj over",
  "alerts.noiseGreaterThanThreshold": "Støj over {value}{unit}",
  "alerts.noiseLessThan": "Støj under",
  "alerts.noiseLessThanThreshold": "Støj under {value}{unit}",
  "alerts.noteOnConditions": "Bemærk at advarslen udløses når alle de nedenstående betingelser er opfyldt",
  "alerts.noTriggerHistory": "Denne alarm er endnu ikke blevet udløst.",
  "alerts.pm10GreaterThan": "PM 10 over",
  "alerts.pm10GreaterThanThreshold": "PM 10 over {value}{unit}",
  "alerts.pm10LessThan": "PM 10 under",
  "alerts.pm10LessThanThreshold": "PM 10 under {value}{unit}",
  "alerts.pm1GreaterThan": "PM1 over",
  "alerts.pm1GreaterThanThreshold": "PM1 over {value}{unit}",
  "alerts.pm1LessThan": "PM 1 under",
  "alerts.pm1LessThanThreshold": "PM 1 under {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2.5 over",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 over {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2.5 under",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 under {value}{unit}",
  "alerts.postStormSummary": "Opsummering efter regn",
  "alerts.postStormSynopsisHelper": "Du får en opsummerende notifikation, hver gang regnvejret slutter.",
  "alerts.postStormSynopsisSoleCondition": "En opsummering efter regn kan ikke kombineres med andre betingelser.",
  "alerts.precipitationGreaterThan": "Timevis nedbør større end",
  "alerts.precipitationGreaterThanThreshold": "Timevis nedbør over grænsen på {value}{unit}",
  "alerts.pressureGreaterThan": "Tryk over",
  "alerts.pressureGreaterThanThreshold": "Tryk over {value}{unit}",
  "alerts.pressureLessThan": "Tryk under",
  "alerts.pressureLessThanThreshold": "Tryk under {value}{unit}",
  "alerts.rainRateGreaterThan": "Regnintensitet større end",
  "alerts.rainRateGreaterThanThreshold": "Regnintensitet over grænsen på {value}{unit}",
  "alerts.sensorNotReporting": "Denne sensor sender ikke data lige nu. Advarslen genoptages, når den sender igen.",
  "alerts.soilMoistureGreaterThan": "Jordfugtighed over",
  "alerts.soilMoistureGreaterThanThreshold": "Jordfugtighed over {value}{unit}",
  "alerts.soilMoistureLessThan": "Jordfugtighed under",
  "alerts.soilMoistureLessThanThreshold": "Jordfugtighed under {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Solstråling over",
  "alerts.solarRadiationGreaterThanThreshold": "Solstråling over {value}{unit}",
  "alerts.solarRadiationLessThan": "Solstråling under",
  "alerts.solarRadiationLessThanThreshold": "Solstråling under {value}{unit}",
  "alerts.stormChartUnavailable": "Regnhistorikken for dette regnvejr er ikke tilgængelig.",
  "alerts.stormDetail": "Opsummering af regnvejr",
  "alerts.stormDuration": "Varighed",
  "alerts.stormEnd": "Slut",
  "alerts.stormPeakRate": "Maksimal regnintensitet",
  "alerts.stormStart": "Start",
  "alerts.stormTotal": "Samlet nedbør",
  "alerts.temperatureGreaterThan": "Temperatur over",
  "alerts.temperatureGreaterThanThreshold": "Temperatur over {value}{unit}",
  "alerts.temperatureLessThan": "Temperatur under",
  "alerts.temperatureLessThanThreshold": "Temperatur under {value}{unit}",
  "alerts.thresholdOutOfRange": "Skal være mellem {min} og {max}",
  "alerts.thswGreaterThan": "THSW over",
  "alerts.thswGreaterThanThreshold": "THSW over {value}{unit}",
  "alerts.thswLessThan": "THSW under",
  "alerts.thswLessThanThreshold": "THSW under {value}{unit}",
  "alerts.thwGreaterThan": "THW over",
  "alerts.thwGreaterThanThreshold": "THW over {value}{unit}",
  "alerts.thwLessThan": "THW under",
  "alerts.thwLessThanThreshold": "THW under {value}{unit}",
  "alerts.triggerHistory": "Alarmhistorik",
  "alerts.uvGreaterThan": "UV index over",
  "alerts.uvGreaterThanThreshold": "UV index over {value}{unit}",
  "alerts.uvLessThan": "UV index under",
  "alerts.uvLessThanThreshold": "UV index under {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Sigtbarhed over {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Sigtbarhed under {value}{unit}",
  "alerts.visiblityGreaterThan": "Sigtbarhed over",
  "alerts.visiblityLessThan": "Sigtbarhed under",
  "alerts.whichMeasure": "Hvilken værdi vil du gerne advares om?",
  "alerts.whichModule": "Hvilket modul vil du blive advaret om?",
  "alerts.whichSensor": "Hvilken sensor vil du blive advaret om?",
  "alerts.windChillGreaterThan": "Vindafkøling over",
  "alerts.windChillGreaterThanThreshold": "Vindafkøling over {value}{unit}",
  "alerts.windChillLessThan": "Vindafkøling under",
  "alerts.windChillLessThanThreshold": "Vindafkøling under {value}{unit}",
  "alerts.windSpeedGreaterThan": "Vindhastighed over",
  "alerts.windSpeedGreaterThanThreshold": "Vindhastighed over {value}{unit}",
  "alerts.windSpeedLessThan": "Vindhastighed under",
  "alerts.windSpeedLessThanThreshold": "Vindhastighed under {value}{unit}",
  "appUpdate.updateAvailable": "Opdatering tilgængelig",
  "appUpdate.updateAvailableOpenAppStore": "Tryk for at åbne App Store",
  "appUpdate.updateAvailableOpenGooglePlay": "Tryk for at åbne Google Play",
  "appUpdate.updateAvailableVersion": "Opdatering tilgængelig: v{version}",
  "appUpdate.upgradeRequiredAndroid": "En opgradering af din applikation er påkrævet. Gå til Google Play for at opgradere.",
  "appUpdate.upgradeRequiredIos": "En opgradering af din applikation er påkrævet. Gå til App Store for at opgradere.",
  "astral.aboveHorizonAllDay": "Over horisonten hele dagen",
  "astral.aboveTheHorizon": "over horisonten",
  "astral.apparentSize": "Vinkelstørrelse",
  "astral.apparentSizeAcross": "{size} i diameter",
  "astral.astronomicalDawn": "Astronomisk morgengry",
  "astral.astronomicalDusk": "Astronomisk tusmørke",
  "astral.belowHorizonAllDay": "Under horisonten hele dagen",
  "astral.belowHorizonSince": "Under horisonten siden kl. {time}",
  "astral.belowHorizonSinceOn": "Under horisonten siden {day} kl. {time}",
  "astral.brightAllNight": "Lyst hele natten — aldrig helt mørkt",
  "astral.brightestMoment": "Lyseste øjeblik",
  "astral.civilDawn": "Borgerligt morgengry",
  "astral.civilDusk": "Borgerligt tusmørke",
  "astral.darkSkyBetween": "Mørk himmel {from} → {to}",
  "astral.darkSkyWindow": "Mørk himmel {from} → {to} · {duration} uden måne",
  "astral.dayLength": "Daglængde",
  "astral.daylightThroughTheYear": "Daglængde gennem året",
  "astral.dayOfCycle": "dag {day} af {total}",
  "astral.doesNotOccurToday": "Sker ikke i dag",
  "astral.domeHint": "Træk for at gå gennem natten",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Tidligste solopgang",
  "astral.earliestSunset": "Tidligste solnedgang",
  "astral.equinox": "Jævndøgn",
  "astral.equinoxIn": "Jævndøgn om {days, plural, one {# dag} other {# dage}}",
  "astral.evening": "Aften",
  "astral.exactPhaseAt": "Præcis kl. {time}",
  "astral.firstQuarter": "Første kvarter",
  "astral.firstSunriseIn": "Første solopgang om {days, plural, one {# dag} other {# dage}}",
  "astral.firstSunsetIn": "Første solnedgang om {days, plural, one {# dag} other {# dage}}",
  "astral.fullMoon": "Fuldmåne",
  "astral.goldenHourBegins": "Den gyldne time begynder",
  "astral.goldenHourEnds": "Den gyldne time slutter",
  "astral.highestPoint": "Højeste punkt",
  "astral.inDays": "om {days, plural, one {# dag} other {# dage}}",
  "astral.lastQuarter": "Sidste kvarter",
  "astral.latestSunrise": "Seneste solopgang",
  "astral.latestSunset": "Seneste solnedgang",
  "astral.litShort": "Belyst",
  "astral.longestDay": "Længste dag",
  "astral.lowestPoint": "Laveste punkt",
  "astral.maxAltitudeShort": "Maks.",
  "astral.midday": "Middag",
  "astral.midnightSun": "Midnatssol",
  "astral.midnightSunPeriod": "Midnatssol",
  "astral.milestoneFootnotePolar": "Her står solen hverken op eller går ned {days, plural, one {# dag} other {# dage}} om året, så i stedet for de sædvanlige yderpunkter for solopgang og solnedgang viser listen, hvornår det sker.",
  "astral.milestoneFootnoteTemperate": "Den tidligste solnedgang og den seneste solopgang falder ikke på den korteste dag — det er tidsligningen, ikke solhvervet, der bestemmer de to datoer.",
  "astral.moon": "Måne",
  "astral.moonAltitude": "Højde",
  "astral.moonDirection": "Azimut",
  "astral.moonDistance": "Afstand",
  "astral.moonlessFor": "{duration} uden måne",
  "astral.moonPhases": "Månefaser",
  "astral.moonrise": "Måneopgang",
  "astral.moonset": "Månenedgang",
  "astral.moonUpAllNight": "Månen er oppe hele natten",
  "astral.moonWashesOutNight": "Månen er oppe fra {rise} til {set} og lyser hele natten op",
  "astral.morning": "Morgen",
  "astral.nauticalDawn": "Nautisk morgengry",
  "astral.nauticalDusk": "Nautisk tusmørke",
  "astral.newMoon": "Nymåne",
  "astral.nextDay": "+1 dag",
  "astral.nextProperlyDarkNight": "Næste rigtigt mørke nat",
  "astral.nextRise": "næste opgang kl. {time}",
  "astral.nextRiseOn": "næste opgang {day} kl. {time}",
  "astral.nextSevenNights": "De næste syv nætter",
  "astral.noAstronomicalDarknessTonight": "Intet astronomisk mørke i nat",
  "astral.noDarkNightAhead": "Ingen de næste to uger",
  "astral.noSunriseToday": "Ingen solopgang i dag",
  "astral.nowAtBearing": "nu {altitude} · azimut {direction}",
  "astral.observing": "Observation",
  "astral.ofDaylightLeft": "dagslys tilbage",
  "astral.overTheNextThreeWeeks": "over de næste 3 uger",
  "astral.percentLit": "{percent} oplyst",
  "astral.polarNight": "Polarnat",
  "astral.polarNightPeriod": "Polarnat",
  "astral.rightNow": "Lige nu",
  "astral.riseShort": "Op",
  "astral.setShort": "Ned",
  "astral.shortestDay": "Korteste dag",
  "astral.solarNoon": "Sand middag",
  "astral.solstice": "Solhverv",
  "astral.sunBelowHorizon": "Solen {degrees}° under horisonten",
  "astral.sunEvents": "Solbegivenheder",
  "astral.sunNeverDarkEnough": "Solen kommer aldrig 18° under horisonten",
  "astral.sunNeverSets": "Solen går ikke ned",
  "astral.sunrise": "Solopgang",
  "astral.sunriseAndSunset": "Solopgang og solnedgang",
  "astral.sunriseAt": "Solopgang kl. {time}",
  "astral.sunset": "Solnedgang",
  "astral.sunsetAt": "Solnedgang kl. {time}",
  "astral.thisYearAtNorth": "I år på {degrees}° N",
  "astral.thisYearAtSouth": "I år på {degrees}° S",
  "astral.tonight": "I nat",
  "astral.twilightAllNight": "Tusmørke hele natten — aldrig helt mørkt",
  "astral.upFor": "{duration} over horisonten",
  "astral.usableLight": "Brugbart lys",
  "astral.vsAverage": "{percent} ift. gns.",
  "astral.vsYesterday": "ift. i går",
  "astral.waningCrescent": "Aftagende månesegl",
  "astral.waningGibbous": "Aftagende trekvartmåne",
  "astral.waxingCrescent": "Tiltagende månesegl",
  "astral.waxingGibbous": "Tiltagende trekvartmåne",
  "astral.whereToLook": "Hvor skal man kigge",
  "astral.withoutTheMoon": "{duration} uden måne",
  "auth.alreadyHaveAccount": "Har du allerede en konto?",
  "auth.authContainerTagline": "Dit personlige vejr-dashboard. Tilslut dine stationer og få realtidsdata lige ved hånden.",
  "auth.backToLogin": "Tilbage til login",
  "auth.checkYourEmail": "Tjek din e-mail",
  "auth.continueWithApple": "Fortsæt med Apple",
  "auth.continueWithFacebook": "Fortsæt med Facebook",
  "auth.continueWithGoogle": "Fortsæt med Google",
  "auth.email": "E-mailadresse",
  "auth.emailRequiredLoginFacebook": "Emailtilladelse er påkrævet",
  "auth.emailVerification": "E-mailbekræftelse",
  "auth.emailVerificationFailure": "Der er opstået et problem med din emailbekræftelse.",
  "auth.emailVerificationSuccess": "Din email er bekræftet.",
  "auth.firstName": "Fornavn",
  "auth.forgotPassword": "Glemt adgangskode?",
  "auth.forgotPasswordSubtitle": "Indtast din e-mail, og vi sender dig et link til at nulstille din adgangskode.",
  "auth.lastName": "Efternavn",
  "auth.login": "Log ind",
  "auth.loginSubtitle": "Velkommen tilbage! Indtast venligst dine oplysninger.",
  "auth.loginToSmartMixinDescription": "Log ind på SmartMixin for at få adgang til dine vejrstationer, se analyser og administrere dit personlige vejr-dashboard.",
  "auth.logout": "Log af",
  "auth.logoutConfirmation": "Vil du logge af?",
  "auth.noAccountYet": "Har du ikke en konto endnu?",
  "auth.or": "eller",
  "auth.password": "Adgangskode",
  "auth.passwordReset": "Nulstil adgangskode",
  "auth.passwordResetSuccess": "Din adgangskode er blevet opdateret.",
  "auth.register": "Opret konto",
  "auth.registerDescription": "Opret en gratis SmartMixin-konto for at forbinde dine vejrstationer, følge vejrdata og få adgang til avancerede analyseværktøjer.",
  "auth.registerSubtitle": "Opret din konto for at komme i gang.",
  "auth.restorePassword": "Gendan adgangskode",
  "auth.restorePasswordSuccess": "Vi har lige sendt dig et link til nulstilling af adgangskode på {emailAddress} med yderligere instruktioner.",
  "auth.sendReset": "Send nulstillingsinstruktioner",
  "auth.signInWithApple": "Log ind med Apple",
  "auth.socialAccount": "eller brug din konto",
  "auth.staffVerificationCode": "Bekræftelseskode",
  "auth.staffVerificationExpiresIn": "Bekræftet. Udløber om {duration}.",
  "auth.staffVerificationInvalidCode": "Forkert kode. Prøv igen.",
  "auth.staffVerificationLoginAsStopped": "Login As blev stoppet: indtast en bekræftelseskode på Debug-skærmen for at fortsætte.",
  "auth.staffVerificationNotEnrolled": "Der er ikke konfigureret nogen godkendelsesapp for din konto. Tilføj en under sikkerhedsindstillingerne i back office.",
  "auth.staffVerificationPrompt": "Indtast den 6-cifrede kode fra din godkendelsesapp eller en gendannelseskode for at bruge Login As og brugersøgning.",
  "auth.staffVerificationSetupLink": "Tilføj en godkendelsesapp",
  "auth.staffVerificationSubmit": "Bekræft",
  "auth.staffVerificationTitle": "Personalebekræftelse",
  "calendar.afternoon": "Eftermiddag",
  "calendar.april": "April",
  "calendar.august": "August",
  "calendar.changePeriod": "Periode: {period}. Skift periode",
  "calendar.currentDay": "I dag",
  "calendar.dateFormat": "Datoformat",
  "calendar.day": "Dag",
  "calendar.december": "December",
  "calendar.durationHours": "{hours} t",
  "calendar.durationHoursMinutes": "{hours} t {minutes} min",
  "calendar.durationMinutes": "{minutes} min",
  "calendar.durationMinutesSeconds": "{minutes} min {seconds} s",
  "calendar.durationSeconds": "{seconds} s",
  "calendar.endTime": "Sluttidspunkt",
  "calendar.evening": "Aften",
  "calendar.february": "Februar",
  "calendar.goToNextDay": "Næste dag",
  "calendar.goToNextMonth": "Næste måned",
  "calendar.goToNextWeek": "Næste uge",
  "calendar.goToNextYear": "Næste år",
  "calendar.goToPreviousDay": "Forrige dag",
  "calendar.goToPreviousMonth": "Forrige måned",
  "calendar.goToPreviousWeek": "Forrige uge",
  "calendar.goToPreviousYear": "Forrige år",
  "calendar.hour": "Time",
  "calendar.hoursCount": "{count, plural, one {# time} other {# timer}}",
  "calendar.hoursShort": "t",
  "calendar.hoursShortCount": "{count, plural, one {# t} other {# t}}",
  "calendar.january": "Januar",
  "calendar.july": "Juli",
  "calendar.june": "Juni",
  "calendar.last12Hours": "Sidste 12 timer",
  "calendar.last24Hours": "Sidste 24 timer",
  "calendar.last30Days": "Sidste 30 dage",
  "calendar.last3Hours": "Sidste 3 timer",
  "calendar.last6Hours": "Sidste 6 timer",
  "calendar.last7Days": "Sidste 7 dage",
  "calendar.lastHour": "Seneste time",
  "calendar.march": "Marts",
  "calendar.max": "Maks.",
  "calendar.may": "Maj",
  "calendar.month": "Måned",
  "calendar.monthTotal": "Månedstotal",
  "calendar.morning": "Morgen",
  "calendar.nextHours": "Næste timer",
  "calendar.night": "Nat",
  "calendar.november": "November",
  "calendar.october": "Oktober",
  "calendar.oneDay": "1-dags",
  "calendar.oneHour": "1-times",
  "calendar.oneMonth": "1-måneds",
  "calendar.oneWeek": "1-uges",
  "calendar.periodRangeSpoken": "{start} til {end}",
  "calendar.previous24Hours": "De foregående 24 timer",
  "calendar.previous30Days": "De foregående 30 dage",
  "calendar.previous7Days": "De foregående 7 dage",
  "calendar.previousDay": "Forrige dag",
  "calendar.previousHours": "Tidligere timer",
  "calendar.previousMonth": "Forrige måned",
  "calendar.previousWeek": "Forrige uge",
  "calendar.previousYear": "Forrige år",
  "calendar.sameDayLastYear": "Samme dag sidste år",
  "calendar.sameMonthLastYear": "Samme måned sidste år",
  "calendar.selectADate": "Vælg en dato",
  "calendar.selectAggregation": "Vælg vist værdi",
  "calendar.selectAMonth": "Vælg en måned",
  "calendar.selectAYear": "Vælg et år",
  "calendar.selectGranularity": "Vælg en granularitet",
  "calendar.selectPeriod": "Vælg en periode",
  "calendar.september": "September",
  "calendar.sixHours": "6-timers",
  "calendar.startTime": "Starttidspunkt",
  "calendar.thirtyMinutes": "30-minutters",
  "calendar.threeHours": "3-timers",
  "calendar.timezone": "Tidszone",
  "calendar.today": "I dag",
  "calendar.untilChanged": "Indtil ændret",
  "calendar.untilTime": "Indtil {time}",
  "calendar.untilTodayAt": "Indtil i dag kl. {time}",
  "calendar.untilTomorrowAt": "Indtil i morgen kl. {time}",
  "calendar.use24HourFormat": "Brug 24-timers format",
  "calendar.week": "Uge",
  "calendar.year": "År",
  "calendar.yearToDate": "Dette år",
  "calendar.yesterday": "I går",
  "charts.averageOverThePeriod": "Gennemsnitligt i perioden",
  "charts.calendarView": "Kalendervisning",
  "charts.charts": "Grafer",
  "charts.chartView": "Grafvisning",
  "charts.comparison": "Sammenligning",
  "charts.customizeComparisonMetrics": "Tilpas sammenligningsmetrikker",
  "charts.customizeComparisonMetricsDescription": "Træk elementer for at ændre rækkefølgen på dine sammenligningsmetrikker. Tryk på øjeikonet for at vise eller skjule metrikker.",
  "charts.maxOverThePeriod": "Maksimum i perioden",
  "charts.measureToDisplay": "Måling der vises",
  "charts.minMaxRange": "Min. / Maks.",
  "charts.noDataForThisPeriod": "Ingen data i denne periode",
  "charts.observations": "Observationer",
  "charts.observedTemperature": "Målt temperatur",
  "charts.showComparison": "Vis sammenligning",
  "charts.stationComparison": "Stationssammenligning",
  "charts.stationComparisonDescription": "Sammenlign historiske vejrdata med en anden station",
  "charts.sumOverThePeriod": "Akkumuleret over perioden",
  "charts.viewAsList": "Liste",
  "charts.viewAsPeriods": "Perioder",
  "common.add": "Tilføj",
  "common.altitude": "Højde",
  "common.analysis": "Analyse",
  "common.average": "Middel",
  "common.back": "Tilbage",
  "common.backToHome": "Tilbage til forsiden",
  "common.cancel": "Annullér",
  "common.cannotBeEmpty": "Dette felt kan ikke være tomt",
  "common.close": "Luk",
  "common.dailyForecast": "Daglig vejrudsigt",
  "common.default": "Standard",
  "common.delete": "Slet",
  "common.details": "Detaljer",
  "common.edit": "Rediger",
  "common.exitFullscreen": "Forlad fuld skærm",
  "common.forecast": "Vejrudsigt",
  "common.frequency": "Frekvens",
  "common.full": "Fuld",
  "common.fullscreen": "Fuld skærm",
  "common.help": "Hjælp",
  "common.hidden": "Skjulte",
  "common.high": "Høj",
  "common.iDontKnowYet": "Jeg ved det endnu ikke",
  "common.indoor": "Indendørs",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Sidste opdatering",
  "common.low": "Lav",
  "common.maximum": "Maksimum",
  "common.medium": "Mellem",
  "common.minimum": "Minimum",
  "common.more": "Mere",
  "common.moreInformation": "Mere information",
  "common.next": "Næste",
  "common.no": "Nej",
  "common.noAccountNeeded": "Ingen konto nødvendig",
  "common.noItemsAvailable": "Ingen elementer tilgængelige",
  "common.notNow": "Ikke nu",
  "common.now": "Nu",
  "common.openSettings": "Åbn indstillinger",
  "common.outdoor": "Udendørs",
  "common.pageNotFound": "Side ikke fundet",
  "common.pageNotFoundDescription": "Siden du leder efter findes ikke eller er blevet flyttet.",
  "common.rain": "Regn",
  "common.share": "Del",
  "common.shareImageFailed": "Billedet kunne ikke deles",
  "common.shareYourWeather": "Del dit vejr",
  "common.skip": "Spring over",
  "common.start": "Start",
  "common.unknown": "Ukendt",
  "common.validate": "Bekræft",
  "common.validEmail": "Der kræves en gyldig emailadresse.",
  "common.very_low": "Meget lav",
  "common.weatherObservations": "Vejrobservationer",
  "common.welcome": "Velkommen til SmartMixin!",
  "common.wind": "Vind",
  "common.yes": "Ja",
  "common.zoomImage": "Zoom på billede",
  "compass.E": "Ø",
  "compass.E_long": "Øst",
  "compass.ENE": "ØNØ",
  "compass.ENE_long": "Øst-Nordøst",
  "compass.ESE": "ØSØ",
  "compass.ESE_long": "Øst-Sydøst",
  "compass.N": "N",
  "compass.N_long": "Nord",
  "compass.NE": "NØ",
  "compass.NE_long": "Nordøst",
  "compass.NNE": "NNØ",
  "compass.NNE_long": "Nord-Nordøst",
  "compass.NNW": "NNV",
  "compass.NNW_long": "Nord-Nordvest",
  "compass.NW": "NV",
  "compass.NW_long": "Nordvest",
  "compass.S": "S",
  "compass.S_long": "Syd",
  "compass.SE": "SØ",
  "compass.SE_long": "Sydøst",
  "compass.SSE": "SSØ",
  "compass.SSE_long": "Syd-Sydøst",
  "compass.SSW": "SSV",
  "compass.SSW_long": "Syd-Sydvest",
  "compass.SW": "SV",
  "compass.SW_long": "Sydvest",
  "compass.W": "V",
  "compass.W_long": "Vest",
  "compass.WNW": "VNV",
  "compass.WNW_long": "Vest-Nordvest",
  "compass.WSW": "VSV",
  "compass.WSW_long": "Vest-Sydvest",
  "dashboard.currentObservations": "Aktuelle observationer",
  "dashboard.currentRainEvent": "Aktuel regnbegivenhed",
  "dashboard.currentWeatherConditions": "Aktuelt vejr",
  "dashboard.customizeDashboard": "Tilpas",
  "dashboard.customizeDashboardDescription": "Træk elementer for at ændre rækkefølgen på dit dashboard. Tryk på øjeikonet for at vise eller skjule sektioner.",
  "dashboard.dashboard": "Dashboard",
  "dashboard.dayRangeExpected": "{value} forventet kl. {time}",
  "dashboard.dayRangeReached": "{value} kl. {time}",
  "dashboard.dayRangeSteady": "Stabilt {value} hele dagen",
  "dashboard.hiddenSensors": "Skjulte sensorer",
  "dashboard.lastRainEvent": "Sidste regnbegivenhed",
  "dashboard.manageSensors": "Administrer sensorer",
  "dashboard.manageSensorsDescription": "Træk elementer for at ændre rækkefølgen af sensorer. Tryk på øjeikonet for at vise eller skjule sensorer. Tryk på et navn for at omdøbe det.",
  "dashboard.pressureSummary": "Trykoversigt",
  "dashboard.rainEvents": "Regnbegivenheder",
  "dashboard.rainSummary": "Nedbørsoversigt",
  "dashboard.shareOutdoorMeasures": "Del dine udendørs målinger",
  "dashboard.shareOutdoorMeasuresDescription": "Deltag i SmartMixin fællesskabet ved at dele dine udendørs målinger. Indendørs bliver aldrig delt",
  "dashboard.temperatureSummary": "Temperaturoversigt",
  "dashboard.windSummary": "Vindoversigt",
  "devices.batteryLevel": "Batteriniveau",
  "devices.firmwareVersion": "Firmwareversion",
  "devices.moduleCount": "{count, plural, one {# modul} other {# moduler}}",
  "devices.moduleType": "Modultype",
  "devices.noNetatmoWeatherStationYet": "Du har ikke en Netatmo vejrstation endnu.",
  "devices.noOutdoorModule": "Der er ikke noget fungerende udendørs modul til denne station.",
  "devices.notReachable": "Ingen forbindelse",
  "devices.serialNumber": "Serienummer",
  "devices.signalAverage": "Moderat",
  "devices.signalBad": "Svag",
  "devices.signalGood": "God",
  "devices.signalStrength": "Signalstyrke",
  "devices.signalUnknown": "Ukendt",
  "devices.visitNetatmoWebsite": "Besøg Netatmos hjemmeside",
  "devices.wifiStrength": "Wi-Fi-styrke",
  "forecastMaps.addColor": "Tilføj farve",
  "forecastMaps.addLayer": "Tilføj lag",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.backToMaps": "Tilbage til kortene",
  "forecastMaps.build": "Generér",
  "forecastMaps.buildCompleted": "Generering fuldført",
  "forecastMaps.builderMetaDescription": "Sammensæt dine egne prognosekort ud fra vejrmodellernes lag.",
  "forecastMaps.builderTitle": "Kortbygger",
  "forecastMaps.buildFailed": "Genereringen mislykkedes. Prøv igen.",
  "forecastMaps.buildNotPossible": "Dette kort kan ikke genereres endnu — der er ingen prognosedata tilgængelige.",
  "forecastMaps.buildProgress": "Renderer… {completed}/{total} trin",
  "forecastMaps.buildStarting": "Starter generering…",
  "forecastMaps.byModel": "Efter model",
  "forecastMaps.byZone": "Efter zone",
  "forecastMaps.colormap": "Farveskala",
  "forecastMaps.colormapCustom": "Brugerdefinerede farver",
  "forecastMaps.colormapGroupDomain": "Vejr-forudindstillinger",
  "forecastMaps.colormapGroupMatplotlib": "Videnskabelige forudindstillinger",
  "forecastMaps.colorScale": "Farveskala",
  "forecastMaps.contourLevels": "Konturniveauer",
  "forecastMaps.countryCanada": "Canada",
  "forecastMaps.countryFrance": "Frankrig",
  "forecastMaps.countryGermany": "Tyskland",
  "forecastMaps.countryItaly": "Italien",
  "forecastMaps.countryScandinavia": "Skandinavien",
  "forecastMaps.countrySpain": "Spanien",
  "forecastMaps.countrySwitzerland": "Schweiz",
  "forecastMaps.countryUnitedStates": "USA",
  "forecastMaps.customColormapMinColors": "En brugerdefineret farveskala kræver mindst to farver",
  "forecastMaps.customExtent": "Brugerdefineret udsnit",
  "forecastMaps.displayName": "Visningsnavn",
  "forecastMaps.downscaling": "Udtyndingsfaktor for vindfaner",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Tegn område",
  "forecastMaps.east": "Øst",
  "forecastMaps.extentDrawHint": "Træk på kortet for at tegne området",
  "forecastMaps.extentInvalid": "Vest skal være mindre end øst, og syd mindre end nord",
  "forecastMaps.height": "Højde (tommer)",
  "forecastMaps.hourOffset": "+{hour} t",
  "forecastMaps.invalidHexColor": "Ugyldig farve — brug #RRGGBB",
  "forecastMaps.layers": "Lag",
  "forecastMaps.layerTypeBarbs": "Vindfaner",
  "forecastMaps.layerTypeContour": "Konturlinjer",
  "forecastMaps.layerTypeFilledContour": "Udfyldte konturer",
  "forecastMaps.layerTypeMagnitude": "Størrelse",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Vektorfelt",
  "forecastMaps.leave": "Forlad",
  "forecastMaps.levelsCount": "Antal",
  "forecastMaps.levelsInvalid": "Ugyldige konturniveauer",
  "forecastMaps.levelsModeArange": "Fast trin",
  "forecastMaps.levelsModeExplicit": "Eksplicitte værdier",
  "forecastMaps.levelsModeLinspace": "Jævnt fordelt (antal)",
  "forecastMaps.levelsStep": "Trin",
  "forecastMaps.levelsValues": "Værdier",
  "forecastMaps.levelsValuesHint": "Kommaseparerede, stigende",
  "forecastMaps.localTimeHint": "Vist i din lokale tid",
  "forecastMaps.mapDescription": "Beskrivelse",
  "forecastMaps.mapName": "Kortnavn",
  "forecastMaps.mapNameRequired": "Indtast et navn",
  "forecastMaps.mapSettings": "Kortindstillinger",
  "forecastMaps.mapView": "Interaktivt kort",
  "forecastMaps.maxLayersReached": "Dette kort har nået maksimum på {max} lag.",
  "forecastMaps.maxValue": "Maksimumværdi",
  "forecastMaps.memoryBudgetExceeded": "Opløsningen overskrider renderingsbudgettet — reducér DPI eller højde",
  "forecastMaps.memoryBudgetUsage": "Renderingsbudget: {percent}%",
  "forecastMaps.metaDescription": "Animerede prognosekort genereret ud fra vejrmodellernes kørsler.",
  "forecastMaps.metric": "Måling",
  "forecastMaps.metricRequired": "Vælg en måling",
  "forecastMaps.metricUnavailable": "Ikke tilgængelig for denne model",
  "forecastMaps.minBelowMax": "Min skal være mindre end maks",
  "forecastMaps.minMaxRequired": "Min- og maks-værdier er påkrævet for denne lagtype",
  "forecastMaps.minValue": "Minimumværdi",
  "forecastMaps.modelNoRun": "Ingen fuldført kørsel endnu",
  "forecastMaps.moveLayerDown": "Flyt ned",
  "forecastMaps.moveLayerUp": "Flyt op",
  "forecastMaps.myMaps": "Mine kort",
  "forecastMaps.nanClipToMin": "Begræns til min",
  "forecastMaps.nanMask": "Maskér",
  "forecastMaps.nanPolicy": "Manglende data",
  "forecastMaps.nanSkip": "Spring over",
  "forecastMaps.noCompletedRun": "Dette kort er ikke genereret endnu. Kig tilbage snart.",
  "forecastMaps.noLayers": "Ingen lag endnu. Tilføj et lag for at komme i gang.",
  "forecastMaps.noMapsAvailable": "Der er endnu ingen tilgængelige prognosekort.",
  "forecastMaps.north": "Nord",
  "forecastMaps.opacity": "Opacitet",
  "forecastMaps.overlayLegend": "Signaturforklaring",
  "forecastMaps.pause": "Pause",
  "forecastMaps.play": "Afspil",
  "forecastMaps.pointValueError": "Prognosen for dette punkt kunne ikke indlæses.",
  "forecastMaps.pointValueLoading": "Indlæser prognose…",
  "forecastMaps.pointValueUnavailable": "Ingen data for dette tidspunkt.",
  "forecastMaps.presets": "Forudindstillinger",
  "forecastMaps.preview": "Forhåndsvisning",
  "forecastMaps.previewEmptyHint": "Konfigurér mindst ét gyldigt lag for at rendere en forhåndsvisning.",
  "forecastMaps.previewFailed": "Forhåndsvisningen mislykkedes",
  "forecastMaps.previewHour": "Prognosetime",
  "forecastMaps.previewRendering": "Renderer forhåndsvisning…",
  "forecastMaps.projection": "Projektion",
  "forecastMaps.projectionLambertConformal": "Lambert konform",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereografisk",
  "forecastMaps.regionEurope": "Europa",
  "forecastMaps.regionNorthAmerica": "Nordamerika",
  "forecastMaps.removeColor": "Fjern farve",
  "forecastMaps.removeLayer": "Fjern lag",
  "forecastMaps.retry": "Prøv igen",
  "forecastMaps.run": "Kørsel: {run}",
  "forecastMaps.save": "Gem",
  "forecastMaps.selectExtentOnMap": "Vælg område på kortet",
  "forecastMaps.south": "Syd",
  "forecastMaps.title": "Prognosekort",
  "forecastMaps.uMetric": "U-komponent",
  "forecastMaps.unitConversion": "Enhedskonvertering",
  "forecastMaps.unitNone": "Ingen",
  "forecastMaps.unsavedChangesBody": "Du har ugemte ændringer. Forlad og kassér dem?",
  "forecastMaps.unsavedChangesTitle": "Ugemte ændringer",
  "forecastMaps.useCurrentView": "Brug nuværende visning",
  "forecastMaps.useModelDomain": "Fra: hele modellens domæne bruges",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "U- og V-målinger skal være forskellige",
  "forecastMaps.valueBetween": "Skal være mellem {min} og {max}",
  "forecastMaps.variable": "Variabel",
  "forecastMaps.viewMap": "Se kort",
  "forecastMaps.vMetric": "V-komponent",
  "forecastMaps.west": "Vest",
  "forecastMaps.windAnimation": "Vindanimation",
  "forecastModels.addForecastModel": "Tilføj en model",
  "forecastModels.atYourStations": "Tilgængelige ved dine stationer",
  "forecastModels.coverageLoading": "Beregner hvilke af dine stationer hver model dækker…",
  "forecastModels.description_AROME": "Météo Frances højopløselige konvektion-tilladende model over Vesteuropa med 1,3 km opløsning. Bedst i klassen for kortsigtede prognoser i Frankrig; opdateret hver tredje time.",
  "forecastModels.description_ARPEGE_EU": "Météo Frances europæiske indlejrede domæne i ARPEGE-modellen med 10 km opløsning. Mellemfristede prognoser over Europa, opdateret fire gange dagligt.",
  "forecastModels.description_ARPEGE_GLOBAL": "Météo Frances globale numeriske vejrmodel med 25 km opløsning, der løber op til ca. 4 dage. Opdateret fire gange dagligt.",
  "forecastModels.description_DMI_DINI": "DMI's HARMONIE DINI: en konvektionsopløsende model over det nordvestlige Europa — Danmark, Benelux, Irland, Storbritannien og Skandinavien — med 2 km opløsning, der løber op til 60 timer, opdateret otte gange dagligt. Indeholder modificerede åbne data fra DMI (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Environment Canadas Global Deterministic Prediction System: en verdensomspændende mellemfristet model med 15 km opløsning, der løber op til 10 dage, opdateret to gange dagligt.",
  "forecastModels.description_EC_HRDPS": "Environment Canadas High Resolution Deterministic Prediction System: en konvektionsopløsende model over Canada og det nordlige USA med 2,5 km opløsning, der løber op til 48 timer, opdateret fire gange dagligt.",
  "forecastModels.description_EC_RDPS": "Environment Canadas Regional Deterministic Prediction System: en mellemfristet model over Nordamerika med 10 km opløsning, opdateret fire gange dagligt.",
  "forecastModels.description_ECMWF_HRES": "Det Europæiske Centers for Mellemfristede Vejrprognosers flagskibsmodel i høj opløsning (IFS), bredt anset som verdens førende globale prognosesystem. Dækker hele planeten med 25 km opløsning op til 15 dage, opdateres fire gange dagligt. Indeholder modificerede åbne data fra ECMWF (CC BY 4.0).",
  "forecastModels.description_GFS": "NOAA's mellemfristede globale flagskibsmodel. Dækker hele planeten med 25 km opløsning op til 16 dage, opdateret fire gange dagligt.",
  "forecastModels.description_HRRR_CONUS": "NOAA's High-Resolution Rapid Refresh: en konvektion-tilladende model over det kontinentale USA med 3 km opløsning, opdateret hver time. Bedst egnet til meget kortsigtede prognoser for tordenvejr og hårdt vejr.",
  "forecastModels.description_ICON": "DWD's globale ICON-model med 13 km opløsning, der dækker hele planeten op til 7,5 dage, opdateret fire gange dagligt. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ItaliaMeteos ICON-2I, drevet sammen med ARPAE: en konvektionsopløsende model over Italien med 2,2 km opløsning, der løber op til 72 timer, opdateret to gange dagligt. Indeholder åbne data fra ItaliaMeteo (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "MeteoSwiss' ICON-CH1-EPS-kontrolkørsel: en konvektionsopløsende model over Alperne med 1 km opløsning, der løber op til 33 timer, opdateret hver tredje time.",
  "forecastModels.description_ICON_CH2": "MeteoSwiss' ICON-CH2-EPS-kontrolkørsel: en konvektionsopløsende model over Alperne — Schweiz og den omkringliggende alperegion — med 2,1 km opløsning, der løber op til 120 timer, opdateret fire gange dagligt.",
  "forecastModels.description_ICON_DE": "DWD's højopløselige konvektion-tilladende model over Tyskland og omkringliggende lande med 2,2 km opløsning. Kortsigtede prognoser opdateret to gange dagligt. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "DWD's europæiske indlejrede domæne i ICON-modellen med 7 km opløsning, der dækker Europa og Nordatlanten. Mellemfristede prognoser opdateret fire gange dagligt. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "Det Norske Meteorologiske Institutts åbne vejrprognosetjeneste, der blander højopløselige nordiske modeller med ECMWF-data for at give verdensomspændende prognoser op til 10 dage frem.",
  "forecastModels.description_MF_AROME_ANTILLES": "Indlejret AROME-domæne over de franske Antiller (Guadeloupe, Martinique) med 2,5 km opløsning. Kortsigtede prognoser opdateret fire gange dagligt.",
  "forecastModels.description_MF_AROME_GUYANE": "Indlejret AROME-domæne over Fransk Guyana med 2,5 km opløsning. Kortsigtede prognoser opdateret fire gange dagligt.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Indlejret AROME-domæne over Ny Kaledonien med 2,5 km opløsning. Kortsigtede prognoser opdateret fire gange dagligt.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Indlejret AROME-domæne over Fransk Polynesien med 2,5 km opløsning. Kortsigtede prognoser opdateret fire gange dagligt.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Indlejret AROME-domæne over Réunion og Mayotte med 2,5 km opløsning. Kortsigtede prognoser opdateret fire gange dagligt.",
  "forecastModels.description_RRFS_CONUS": "NOAA's Rapid Refresh Forecast System over det kontinentale USA med 3 km opløsning. Timeprognoser opdateret otte gange dagligt, op til 84 timer på de fire hovedkørsler og 18 timer på de øvrige.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "NOAA's Rapid Refresh Forecast System for hele Nordamerika med 13 km opløsning. Timeprognoser op til 84 timer, opdateret fire gange dagligt.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "SmartMixins flagskibsprognose. For hver time på din placering vælger vi den bedste tilgængelige model — typisk en højopløselig regional model, hvor en sådan findes (AROME i Frankrig, ICON-D2 i Tyskland, HRRR i USA, ARPEGE Europe på tværs af kontinentet…) og falder tilbage til en global model andre steder — og udfylder så eventuelle huller fra nabokilder. Resultatet er en enkelt, sammenhængende prognose, der dækker hvor som helst i verden op til 14 dage, automatisk opdateret hver gang en af de underliggende modeller opdateres.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Weatherflows proprietære globale prognose, der blander flere numeriske vejrmodeller med observationer fra dets netværk af Tempest-vejrstationer. 10-dages verdensomspændende horisont.",
  "forecastModels.everywhereElse": "Alle andre steder",
  "forecastModels.everywhereElseFoot": "Bruges ved enhver station, dine foretrukne modeller ikke når.",
  "forecastModels.everywhereElsePick": "Vælg én",
  "forecastModels.fallbackBlend": "SmartMixin-blanding",
  "forecastModels.fallbackBlendSub": "Kombinerer flere modeller, hver dér hvor den er stærkest.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES overalt hvor den rækker.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "NOAA's globale model. Det, alle konti bruger i dag.",
  "forecastModels.fallbackResolution": "Højeste opløsning",
  "forecastModels.fallbackResolutionSub": "Det fineste gitter, der er tilgængeligt ved hver station.",
  "forecastModels.forecastChipLabelWithRun": "{model}, kørsel {run}",
  "forecastModels.forecastChipRunHint": "Tryk længe for at vise eller skjule den seneste kørsel",
  "forecastModels.forecastComparisonDescription": "Sammenlign nemt data fra flere kilder",
  "forecastModels.forecastFollowingPreferences": "Følger dine præferencer",
  "forecastModels.forecastModel": "Prognosemodel",
  "forecastModels.forecastModelComparison": "Sammenligning af vejrudsigtsmodeller",
  "forecastModels.forecastModelCoverage": "Dækning",
  "forecastModels.forecastModelDescription": "Beskrivelse",
  "forecastModels.forecastModels": "Prognosemodeller",
  "forecastModels.forecastModelScopeGlobal": "Global",
  "forecastModels.forecastModelScopeGlobalDescription": "Denne model dækker hele kloden.",
  "forecastModels.forecastModelScopeRegional": "Regional",
  "forecastModels.forecastModelScopeRegionalDescription": "Denne model dækker kun en bestemt region.",
  "forecastModels.forecastModelSpecifications": "Specifikationer",
  "forecastModels.forecastNoPinLocation": "Ingen foretrukken model når denne placering — »alle andre steder« bestemmer.",
  "forecastModels.forecastNoPinStation": "Ingen foretrukken model når denne station — »alle andre steder« bestemmer.",
  "forecastModels.forecastNoPreferredModels": "Ingen foretrukne modeller angivet endnu.",
  "forecastModels.forecastOverrideElsewhere": "Dine præferencer gælder alle andre steder.",
  "forecastModels.forecastPickForLocation": "Eller vælg en til denne placering",
  "forecastModels.forecastPickForStation": "Eller vælg en til denne station",
  "forecastModels.forecastPinWinsLocation": "{model} — din første foretrukne model, der når denne placering.",
  "forecastModels.forecastPinWinsStation": "{model} — din første foretrukne model, der når denne station.",
  "forecastModels.forecastServedNowHere": "Lige nu er det {model} her",
  "forecastModels.forecastSetForLocation": "Angivet for denne placering",
  "forecastModels.forecastSetForStation": "Angivet for denne station",
  "forecastModels.forecastSettingsRowSub": "Foretrukne modeller, og hvad der gælder alle andre steder",
  "forecastModels.forecastStopUsingHere": "Brug ikke her længere",
  "forecastModels.forecastUseForLocation": "Brug {model} til denne placering",
  "forecastModels.forecastUseForStation": "Brug {model} til denne station",
  "forecastModels.forecastUsePreferred": "Brug mine foretrukne modeller",
  "forecastModels.frequencyHourly": "Hver time",
  "forecastModels.horizon": "Vejrudsigtsperiode",
  "forecastModels.horizonValue": "op til {value} timer",
  "forecastModels.meshSize": "Gitterstørrelse",
  "forecastModels.pickerShowAll": "Vis hele kataloget",
  "forecastModels.pickerUnreachable": "{count, plural, one {# model mere når} other {# modeller mere når}} ingen af dine stationer",
  "forecastModels.pinInUse": "I brug",
  "forecastModels.pinShadowed": "Bruges aldrig — en model ovenfor dækker alle dine stationer",
  "forecastModels.pinSlots": "{used} af {max} · vælg en model",
  "forecastModels.pinSlotsFull": "{max, plural, one {Den eneste plads er i brug. Fjern dens model for at tilføje en anden.} other {Alle # pladser er i brug. Fjern én for at tilføje en anden.}}",
  "forecastModels.pinsUncoveredCount": "{used} af dine {count, plural, one {# station} other {# stationer}}: ingen foretrukken model når {used, plural, one {den} other {dem}} — »alle andre steder« bestemmer.",
  "forecastModels.pinsUncoveredNamed": "{stations}: ingen foretrukken model når {count, plural, one {den} other {dem}} — »alle andre steder« bestemmer.",
  "forecastModels.pinUnreachable": "Bruges aldrig — den når ingen af dine stationer",
  "forecastModels.pinUsedAt": "Bruges ved {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, one {Bruges ved din station} other {Bruges ved alle # stationer}}",
  "forecastModels.pinUsedAtSome": "Bruges ved {used} af {count, plural, one {# station} other {# stationer}}",
  "forecastModels.preferredModels": "Foretrukne modeller",
  "forecastModels.preferredModelsAll": "Én liste, alle stationer",
  "forecastModels.preferredModelsOne": "Én liste, gælder overalt",
  "forecastModels.publisher": "Udgiver",
  "forecastModels.removePreferredModel": "Fjern {model} fra dine foretrukne modeller",
  "forecastModels.resetForecastPreference": "Nulstil",
  "forecastModels.resetForecastPreferenceHint": "Rydder dine foretrukne modeller og vender tilbage til SmartMixins standard.",
  "forecastModels.servedNowMany": "Lige nu: GFS {count, plural, one {ved din station} other {ved alle # stationer}}.",
  "forecastModels.servedNowNone": "Lige nu: GFS overalt.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin multimodel",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Weatherflow-prognose",
  "forecastModels.weatherForecastModels": "Vejrudsigtsmodeller",
  "helpCenter.articleCount": "{count, plural, one {# artikel} other {# artikler}}",
  "helpCenter.articleNotFound": "Artikel ikke fundet",
  "helpCenter.articleNotFoundDescription": "Den artikel, du leder efter, findes ikke.",
  "helpCenter.backToHelpCenter": "Tilbage til hjælpecenter",
  "helpCenter.browseByCategory": "Gennemse efter kategori",
  "helpCenter.categoryNotFound": "Kategori ikke fundet",
  "helpCenter.categoryNotFoundDescription": "Denne kategori findes ikke eller har ingen artikler.",
  "helpCenter.contactSupport": "Kontakt support",
  "helpCenter.feedbackHelpsImprove": "Din feedback hjælper os med at forbedre vores hjælpeartikler.",
  "helpCenter.feedbackReasonNotAnswer": "Den besvarer ikke mit spørgsmål",
  "helpCenter.feedbackReasonOutdated": "Oplysningerne er forældede",
  "helpCenter.feedbackReasonUnclear": "Instruktionerne er uklare",
  "helpCenter.feedbackWhatWentWrong": "Hvad var problemet?",
  "helpCenter.helpCategoryAccount": "Konto",
  "helpCenter.helpCategoryBilling": "Fakturering",
  "helpCenter.helpCategoryForecast": "Prognoser",
  "helpCenter.helpCategoryGettingStarted": "Kom i gang",
  "helpCenter.helpCategoryProviders": "Udbydere",
  "helpCenter.helpCategoryStations": "Stationer",
  "helpCenter.helpCategoryTroubleshooting": "Fejlfinding",
  "helpCenter.helpCenter": "Hjælpecenter",
  "helpCenter.landingDescription": "Find svar på almindelige spørgsmål og lær, hvordan du får mest muligt ud af SmartMixin.",
  "helpCenter.linkToSection": "Link til dette afsnit",
  "helpCenter.menuItemDescription": "Ofte stillede spørgsmål og vejledninger",
  "helpCenter.minRead": "{minutes} min læsning",
  "helpCenter.onThisPage": "På denne side",
  "helpCenter.platformMobileApp": "Mobilapp",
  "helpCenter.platformMobileOnly": "Kun i mobilappen",
  "helpCenter.platformWebApp": "Webapp",
  "helpCenter.platformWebOnly": "Kun i webappen",
  "helpCenter.popularArticles": "Populære artikler",
  "helpCenter.relatedArticles": "Relaterede artikler",
  "helpCenter.searchArticles": "Søg artikler...",
  "helpCenter.stillNeedHelp": "Har du stadig brug for hjælp?",
  "helpCenter.stillNeedHelpDescription": "Hvis denne artikel ikke besvarede dit spørgsmål, hjælper jeg dig gerne direkte.",
  "helpCenter.supportEmailSubject": "SmartMixin-hjælp",
  "helpCenter.supportEmailSubjectTopic": "SmartMixin-hjælp — {topic}",
  "helpCenter.thankYouForFeedback": "Tak for din feedback!",
  "helpCenter.wasArticleHelpful": "Var denne artikel nyttig?",
  "intro.locationDescription": "Aktivér lokationsadgang for at få præcise vejrudsigter tilpasset dit nøjagtige område — ikke flere vejrudsigter, som passer til alle.",
  "intro.locationTitle": "Prognoser skabt til dig",
  "intro.notificationDescription": "Slå notifikationer til og få rettidige advarsler om vejrændringer, der betyder noget for dig — regn, sne eller ekstreme forhold, lige når du har brug for det.",
  "intro.notificationsTitle": "Gå aldrig glip af en vejrændring",
  "intro.readyDescription": "Nyd præcise prognoser, vejrindsigt i realtid og stationsdata fra hele verden — alt i én kraftfuld app.",
  "intro.readyTitle": "Du er klar!",
  "intro.welcomeDescription": "Få hyperlokale prognoser fra førende vejrtjenester — plus adgang til over 40.000 vejrstationer verden over for at se de faktiske forhold, både nu og tidligere.",
  "intro.welcomeTitle": "Dit vejr, genopfundet",
  "landing.alsoAvailableOn": "Også tilgængelig på:",
  "landing.featureAlertsDescription": "Indstil egne tærskelværdier for enhver måling. Få besked, når temperaturen falder, regnen begynder, eller vinden tager til.",
  "landing.featureAlertsTitle": "Smarte advarsler",
  "landing.featureAnalyticsDescription": "Interaktive diagrammer, trendanalyse og detaljerede statistikker. Dyk ned i data om temperatur, luftfugtighed, lufttryk, regn og vind.",
  "landing.featureAnalyticsTitle": "Avanceret analyse",
  "landing.featureExportDescription": "Få alle dine vejrdata på e-mail som et Excel-regneark, klar til videre analyse i Excel, Google Sheets eller dine foretrukne værktøjer.",
  "landing.featureExportTitle": "Eksportér dine data",
  "landing.featureForecastDescription": "Få adgang til {count, plural, one {#+ professionel prognosemodel} other {#+ professionelle prognosemodeller}}, herunder ECMWF, GFS og regionale modeller. Sammenlign dem side om side, og lav dine egne forudsigelser.",
  "landing.featureForecastTitle": "Sammenlign prognosemodeller",
  "landing.featureHistoryDescription": "Få adgang til historiske data med time-, dags- og månedsskala. Eksporter dem til Excel til forskning eller personlige arkiver.",
  "landing.featureHistoryTitle": "Rig historik",
  "landing.featureMultiBrandDescription": "Forbind Netatmo, Davis, Tempest, Ecowitt, Ambient Weather og flere. Slut med at skifte mellem apps.",
  "landing.featureMultiBrandTitle": "Alle mærker, én app",
  "landing.featuresSubtitle": "SmartMixin giver dig værktøjerne til at analysere, sammenligne og forstå dine vejrdata som en professionel.",
  "landing.featuresTitle": "Skabt til dataelskere",
  "landing.finalCtaButton": "Opret gratis konto",
  "landing.finalCtaSubtitle": "Bliv en del af tusindvis af vejrentusiaster, der stoler på SmartMixin.",
  "landing.finalCtaTitle": "Klar til at dykke dybere ned i dine vejrdata?",
  "landing.heroCta": "Start gratis",
  "landing.heroDescription": "Dybdegående analyse, flotte diagrammer og professionelle prognoser — alle dine vejrstationer samlet i én kraftfuld app.",
  "landing.heroSecondaryCta": "Udforsk kortet",
  "landing.heroTagline": "For vejrentusiaster",
  "landing.heroTitle": "Se dit vejr som aldrig før",
  "landing.pricingFeatureAdvancedMetrics": "Avancerede målinger",
  "landing.pricingFeatureAlerts": "Tilpassede advarsler",
  "landing.pricingFeatureExport": "Dataeksport (Excel)",
  "landing.pricingFeatureForecastComparison": "Prognosesammenligning",
  "landing.pricingFeatureForecasts": "Prognosemodeller",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ model} other {#+ modeller}}",
  "landing.pricingFeatureReports": "Analyser og rapporter",
  "landing.pricingFeatureStationComparison": "Stationssammenligning",
  "landing.pricingFeatureWidgets": "Startskærm-widgets",
  "landing.pricingFeatureYearOverYear": "År-til-år-analyse",
  "landing.pricingFreeCta": "Kom i gang",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Mest populær",
  "landing.pricingPremiumCta": "Kom i gang",
  "landing.pricingPremiumDescription": "Fra 1,99 €/måned — abonner på web, App Store eller Google Play",
  "landing.pricingSubtitle": "Start gratis, opgrader når du har brug for mere.",
  "landing.pricingTitle": "Enkel, gennemsigtig prissætning",
  "landing.statBrands": "Understøttede mærker",
  "landing.statForecasts": "Prognosemodeller",
  "landing.statStations": "Vejrstationer",
  "landing.supportedDevicesNote": "Plus mere end {count, number} offentlige stationer fra Verdens Meteorologiske Organisations netværk",
  "landing.supportedDevicesSubtitle": "Tilslut din eksisterende vejrstation på få minutter. Vi understøtter {count, plural, one {# stort mærke} other {# store mærker}}, og der kommer flere til.",
  "landing.supportedDevicesTitle": "Fungerer med din station",
  "metrics.absolutePressure": "Absolut lufttryk",
  "metrics.airDensity": "Luftdensitet",
  "metrics.airGap": "Luftspalte",
  "metrics.apparentTemperature": "Tilsyneladende temperatur",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Gns.",
  "metrics.avg_wind": "Gennemsnitlig vindstyrke",
  "metrics.beaufort": "Beaufort",
  "metrics.blackGlobeTemperature": "Sortglobe temp.",
  "metrics.boilerOn": "Kedel tændt",
  "metrics.boilerOnInHours": "Kedel tændt (timer)",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Ledningsevne",
  "metrics.dailyPrecipitation": "Daglig nedbør",
  "metrics.dailyRain": "Daglig regn",
  "metrics.degreeDayShort": "DD",
  "metrics.depth": "Dybde",
  "metrics.depthSensors": "Dybdesensorer",
  "metrics.dewPoint": "Dugpunkt",
  "metrics.distance": "Afstand",
  "metrics.downTrend": "Ned",
  "metrics.ET": "Evapotranspiration",
  "metrics.etToday": "ET i dag",
  "metrics.feelsLike": "Føles som",
  "metrics.feelsLikeWithFormula": "Føles som ({formula})",
  "metrics.frostPoint": "Frostpunkt",
  "metrics.gust": "Vindstød",
  "metrics.hail": "Hagl",
  "metrics.heatIndex": "Varmeindeks",
  "metrics.heatingDegreeDays": "Varmegradsdage",
  "metrics.heatingPower": "Varmeeffekt",
  "metrics.humidex": "Humidex",
  "metrics.humidity": "Luftfugtighed",
  "metrics.lastLightningImpact": "Sidste nedslag",
  "metrics.lastMeasure": "Sidste måling",
  "metrics.leafSensors": "Bladfølere",
  "metrics.leafWetness": "Bladfugt",
  "metrics.lightningDistance": "Afstand",
  "metrics.lightningStrikeCount": "Antal lynnedslag",
  "metrics.lightningStrikeDistance": "Lynnedslagsafstand",
  "metrics.max": "Maks.",
  "metrics.max_gust": "Maks. vindstød",
  "metrics.maxToday": "Maks. i dag",
  "metrics.min": "Min.",
  "metrics.noise": "Støj",
  "metrics.normalizedHeatingCoefficient": "Normaliseret varmekoefficient",
  "metrics.outdoorTemperature": "Udetemperatur",
  "metrics.PM_1": "PM1",
  "metrics.PM_10": "PM10",
  "metrics.PM_2P5": "PM2.5",
  "metrics.precipitation": "Nedbør",
  "metrics.pressure": "Lufttryk",
  "metrics.rain": "Regn",
  "metrics.rainDurationValue": "Regnvarighed: {duration}",
  "metrics.rainfallMeasurement": "Måling af nedbør",
  "metrics.rainRate": "Regnintensitet",
  "metrics.relativePressure": "Relativt lufttryk",
  "metrics.setPoint": "Sætpunkt",
  "metrics.snow": "Sne",
  "metrics.snowfall": "Snefald",
  "metrics.soilMoisture": "Fugtighed",
  "metrics.soilSensors": "Jordfølere",
  "metrics.soilWaterTension": "Jordvandsspænding",
  "metrics.solarEnergy": "Solenergi",
  "metrics.solarRadiation": "Solstråling",
  "metrics.speed": "Hastighed",
  "metrics.stableTrend": "Stabil",
  "metrics.sum": "Sum",
  "metrics.temperature": "Temperatur",
  "metrics.temperatureSensors": "Temperatur- og fugtighedsmålere",
  "metrics.temperatureShort": "Temp.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "op",
  "metrics.uv": "UV",
  "metrics.visibility": "Sigtbarhed",
  "metrics.weatherCondition": "Vejrforhold",
  "metrics.wetBulbGlobeTemperature": "Våd kugletemperatur",
  "metrics.wetBulbTemperature": "Vådtemperatur",
  "metrics.wind": "Vind",
  "metrics.windChill": "Vindafkøling",
  "metrics.windDirection": "Vindretning",
  "metrics.windMeasurement": "Vindmåling",
  "metrics.windRun": "Vinddistance",
  "metrics.windRunDescription": "Vinddistance er den samlede afstand, vinden tilbagelægger over en periode",
  "metrics.windSpeed": "Vindhastighed",
  "network.cancelError": "Forespørgslen er blevet annulleret",
  "network.connectionError": "Serveren er ikke tilgængelig",
  "network.networkError": "Netværket er ikke tilgængeligt",
  "network.serverError": "Der er noget galt...",
  "network.timeoutError": "Forbindelsen fik timeout",
  "network.unknownError": "Ukendt fejl",
  "premium.alreadyPremium": "Du har allerede en premiumkonto!",
  "premium.bestValue": "Bedste køb",
  "premium.billingDetailsAndroid": "Gratis prøveperiode: Du bliver ikke opkrævet, hvis du opsiger mindst 24 timer før prøveperioden slutter. Derefter fornyes dit SmartMixin-abonnement automatisk, medmindre du opsiger det mindst 24 timer før udgangen af den aktuelle periode; du kan opsige når som helst i dine kontoindstillinger i Google Play. Hver fornyelse opkræves til den pris, der vises på knappen ovenfor. Betalingen opkræves på din Google Play-konto, når du bekræfter købet, og ved starten af hver fornyelsesperiode.",
  "premium.billingDetailsIos": "Gratis prøveperiode: Du bliver ikke opkrævet, hvis du opsiger mindst 24 timer før prøveperioden slutter. Derefter fornyes dit SmartMixin-abonnement automatisk, medmindre du opsiger det mindst 24 timer før udgangen af den aktuelle periode; du kan opsige når som helst i dine kontoindstillinger i App Store. Hver fornyelse opkræves til den pris, der vises på knappen ovenfor. Betalingen opkræves på din App Store-konto, når du bekræfter købet, og ved starten af hver fornyelsesperiode.",
  "premium.freeBannerBody": "Gratis konti får GFS overalt — dine foretrukne modeller og »alle andre steder« træder i kraft, så snart du abonnerer.",
  "premium.freeBannerTitle": "Præferencer gælder med Premium",
  "premium.freeSubscription": "Gratis premiumabonnement",
  "premium.freeTrialForPeriod": "Gratis prøveperiode i {period, plural, one {# dag} other {# dage}}",
  "premium.getUnlimitedAccess": "Ubegrænset adgang til:",
  "premium.manageMySubscription": "Administrer mit abonnement",
  "premium.notPurchasedYet": "Der blev ikke fundet noget køb af SmartMixin Premium for denne butikskonto.",
  "premium.orChooseMonthly": "Eller vælg månedligt:",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Aktiv",
  "premium.premiumAnnualTrialInfo": "Start med en gratis prøveperiode på {days, plural, one {# dag} other {# dage}}",
  "premium.premiumCurrentPlan": "Nuværende abonnement",
  "premium.premiumDownloadApp": "Download appen for at abonnere:",
  "premium.premiumEndsOn": "Udløber {date}",
  "premium.premiumFeatureAlerts": "Vejradvarsler",
  "premium.premiumFeatureAnalysis": "Avanceret vejranalyse",
  "premium.premiumFeatureCharts": "Grafsammenligninger",
  "premium.premiumFeatureExport": "Dataeksport",
  "premium.premiumFeatureForecast": "Regionale prognosemodeller",
  "premium.premiumFeatureNotification": "Statuslinje-widget",
  "premium.premiumFeatureTitle": "Premium-funktion",
  "premium.premiumFeatureWidgets": "Startskærm-widgets",
  "premium.premiumFreePlan": "Gratis",
  "premium.premiumInactive": "Ikke abonneret",
  "premium.premiumManageStoreSubscription": "Du abonnerer via {store}. Administrer eller opsig dit abonnement der.",
  "premium.premiumManageWebSubscription": "Administrer dit abonnement, opdater betalingsmetode eller annuller.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Fornyes {date}",
  "premium.premiumSubscribeAnnual": "Årligt — 9,99 €/år",
  "premium.premiumSubscribedOn": "Abonneret på {platform}",
  "premium.premiumSubscribedOnWeb": "Abonneret på nettet",
  "premium.premiumSubscribeMonthly": "Månedligt — 1,99 €/måned",
  "premium.premiumSubscribeOnWeb": "Abonner nu for at låse op for alle premium-funktioner.",
  "premium.premiumSubscriptionSuccess": "Dit abonnement er aktiveret! Nyd alle premium-funktioner.",
  "premium.premiumSubscriptionSuccessTitle": "Velkommen til Premium!",
  "premium.premiumWebappNotice": "Det er ikke muligt at abonnere på nettet lige nu.",
  "premium.pricePerMonth": "{price}/måned",
  "premium.pricePerYear": "{price}/år",
  "premium.purchasedNetatmoPro": "Du har tidligere købt Netatmo Pro ({date}). Det giver dig adgang til en del af premium-funktionerne. Abonner på et af følgende tilbud, hvis du vil have adgang til alle premium-funktioner.",
  "premium.purchaseFailed": "Købet kunne ikke gennemføres. Prøv igen.",
  "premium.restoreFailed": "Dine køb kunne ikke gendannes. Prøv igen.",
  "premium.restorePurchase": "Gendan tidligere køb",
  "premium.savingsPercent": "Spar {percent}%",
  "premium.seePremium": "Se Premium",
  "premium.startFreeTrial": "Start gratis prøveperiode",
  "premium.storeUnavailable": "Butikken er ikke tilgængelig lige nu. Prøv igen senere.",
  "premium.subscribeNow": "Abonner nu — uden prøveperiode",
  "premium.switchToPremium": "Skift til SmartMixin Premium",
  "premium.thenPrice": "derefter {price}",
  "providerHints.ambientWeatherApiKey": "Oprettet i kontoindstillingerne på ambientweather.net.",
  "providerHints.davisApiSecret": "Vises kun én gang ved oprettelse af V2 API-nøglen — opbevar sikkert.",
  "providerHints.davisV2ApiKey": "Fra V2 API-nøglesiden på weatherlink.com.",
  "providerHints.ecowittApi": "Fra API-siden i din Ecowitt-konto.",
  "providerHints.ecowittApp": "Programnøglen, også fra din Ecowitt-konto.",
  "providerHints.myAcuriteCredentialsBanner": "Brug e-mail og adgangskode til din My AcuRite-konto — ikke SmartMixin-login.",
  "providerHints.myAcuriteEmail": "E-mailadressen på din My AcuRite-konto — ikke dit SmartMixin-login.",
  "providerHints.myAcuritePassword": "Adgangskoden til din My AcuRite-konto.",
  "providerHints.weatherflowToken": "Personlig token fra tempestwx.com → indstillinger → dataautorisationer.",
  "providerHints.wundergroundEditKey": "Brug en anden nøgle",
  "providerHints.wundergroundKey": "En lang streng fra API-nøglesiden i din Weather Underground-konto — ikke din wunderground.com-adgangskode.",
  "providerHints.wundergroundKeyExample": "f.eks. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API-nøgle verificeret",
  "providerHints.wundergroundNoStationsNearby": "Ingen stationer fundet i nærheden. Prøv at indtaste et stations-ID direkte.",
  "providerHints.wundergroundStationIdExample": "f.eks. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Hent din Ambient Weather API-nøgle.",
  "providerIntro.davisStep2": "Hent din Davis V2 API-nøgle og API-hemmelighed.",
  "providerIntro.ecowittStep2": "Hent din Ecowitt API-nøgle og programnøgle.",
  "providerIntro.getStarted": "Kom i gang",
  "providerIntro.myAcuriteStep2": "Brug e-mail og adgangskode til din eksisterende My AcuRite-konto.",
  "providerIntro.netatmoEnergyStep2": "Log ind på Netatmo, når du bliver bedt om det — ingen API-nøgle nødvendig.",
  "providerIntro.netatmoWeatherStep2": "Log ind på Netatmo, når du bliver bedt om det — ingen API-nøgle nødvendig.",
  "providerIntro.signupBanner": "Næsten færdig — opret din gratis SmartMixin-konto for at forbinde {provider}.",
  "providerIntro.step1": "Log ind på din SmartMixin-konto (IKKE dit {provider}-login).",
  "providerIntro.step3EmailPassword": "Indtast dem her.",
  "providerIntro.step3KeyOrToken": "Indsæt den her.",
  "providerIntro.step3OAuth": "Godkend SmartMixin i popup-vinduet.",
  "providerIntro.step3Wunderground": "Indsæt din API-nøgle, og vælg derefter en station i nærheden, eller indtast et hvilket som helst stations-ID.",
  "providerIntro.title": "Forbind {provider}",
  "providerIntro.weatherflowStep2": "Hent din personlige Tempest-token.",
  "providerIntro.wundergroundBrowsePublic": "Har du ingen station? Gennemse offentlige",
  "providerIntro.wundergroundFindNearby": "Find stationer i nærheden",
  "providerIntro.wundergroundOrEnterId": "Eller indtast et stations-ID",
  "providerIntro.wundergroundStep2": "Hent din Weather Underground API-nøgle. Du kan derefter forbinde enhver station — din egen eller en offentlig.",
  "reports.agroMeteorology": "Agrometeorologi",
  "reports.analysis": "Analyse",
  "reports.annualCumulativeRainfallComparison": "Årlig kumulativ nedbør sammenligning",
  "reports.annualHeatingDurationComparison": "Sammenligning af årlig opvarmningsvarighed",
  "reports.annualHeatingEfficiency": "Årlig opvarmningseffektivitet",
  "reports.annualIndoorComparison": "Årlig indendørssammenligning",
  "reports.annualOutdoorComparison": "Årlig udendørssammenligning",
  "reports.annualOutdoorReport": "Årlig udendørsrapport",
  "reports.annualReport": "Årlig rapport",
  "reports.annualSolarReport": "Årlig sol rapport",
  "reports.annualWaterBalance": "Årlig vand balance",
  "reports.annualWaterBalanceCarryOver": "Overfør {year} ({value})",
  "reports.annualWaterBalanceDescription": "Vandbalancen (forenklet version, kun regn og evapotranspiration anvendes) hjælper med at styre vandforsyningen",
  "reports.avgHumidity": "Gennemsnitlig luftfugtighed",
  "reports.avgMaxTemperature": "Gennemsnitlig T°maks",
  "reports.avgMetric": "Gennemsnit – {metric}",
  "reports.avgMinTemperature": "Gennemsnitlig T°min",
  "reports.avgPressure": "Gennemsnitligt lufttryk",
  "reports.avgTemperature": "Gennemsnitstemperatur",
  "reports.chartsAndTable": "Grafer og tabel",
  "reports.climateNormalPeriodOfRecord": "Måleperiode ({years} år)",
  "reports.climateNormals": "Klimanormaler",
  "reports.climateNormalStandardLabel": "Standardnormal ({period})",
  "reports.climateTrendPerDecade": "Temperaturtendens: {value} pr. årti over {years} år",
  "reports.coldestMonthRanking": "Koldeste {month} nogensinde målt",
  "reports.comfortable": "Komfortabelt (45% {lessThan} luftfugtighed ≤ 60%)",
  "reports.cumulativeRainfall": "Kumulativ nedbør",
  "reports.cumulativeRainfallDescription": "Følg den samlede nedbør, der akkumuleres over den valgte periode.",
  "reports.dailyMaxRainfall": "Daglig maks. nedbør",
  "reports.dataExport": "Eksporter data",
  "reports.dataExportXlsxFormatDescription": "Eksporterer alle vejrstationes data i Excel-format (* .xlsx). Når du har klikket på knappen, vil du efter et par minutter modtage en email med de behandlede data.",
  "reports.daysOfData": "{days, plural, one {# dags data} other {# dages data}}",
  "reports.daysWithFrost": "Dage med frostvejr",
  "reports.daysWithHeavyRain": "Dage med kraftig regn (≥ {threshold})",
  "reports.daysWithoutThaw": "Dage uden tøvejr",
  "reports.daysWithStrongFrost": "Dage med hård frost",
  "reports.emailSent": "Der er sendt en email til dig",
  "reports.frostDays": "Frostdage",
  "reports.grasslandTemperatureSum": "Græsmarkstemperatursum",
  "reports.grasslandTemperatureSumDescription": "Hvis det samlede {threshold} overskrides om foråret, vil det bæredygtige start af vegetation være opnået",
  "reports.growingDegreeDays": "Vækstgraddage",
  "reports.highPressure": "Højt lufttryk (gns. lufttryk ≥ 1013 mbar)",
  "reports.iceDays": "Isdage",
  "reports.indoorReport": "Indendørsrapport",
  "reports.keyFacts": "Nøglefakta",
  "reports.longestDrySpell": "Længste tørre periode",
  "reports.longestRunOfRainyDays": "Længste forløb af regnvejrsdage",
  "reports.longestRunWithoutRun": "Længste forløb uden regn",
  "reports.longestWetSpell": "Længste våde periode",
  "reports.lowPressure": "Lavt lufttryk (gns. lufttryk {lessThan} 1013 mbar)",
  "reports.maxHumidity": "Maks. luftfugtighed",
  "reports.maxMetric": "Maksimum – {metric}",
  "reports.maxPressure": "Maks. lufttryk",
  "reports.maxTemperature": "Maksimumstemperatur",
  "reports.maxTempGreaterThan": "T°maks. ≥",
  "reports.maxTempMagnitude24h": "Største udsving (/24t)",
  "reports.minHumidity": "Min. luftfugtighed",
  "reports.minMetric": "Minimum – {metric}",
  "reports.minPressure": "Min. lufttryk",
  "reports.minTemperature": "Minimumstemperatur",
  "reports.minTempMagnitude24h": "Mindste udsving (/24t)",
  "reports.monthlyAverageCountdown": "{days, plural, one {# dag mere} other {# dage mere}} denne måned",
  "reports.monthlyAverageCountdownDetail": "Så vises månedens gennemsnit og placering.",
  "reports.monthlyAverageRule": "Månedlige gennemsnit og placeringer vises, når en kalendermåned har {days, plural, one {# dag} other {# dage}} registreret.",
  "reports.monthlyHeatingEfficiency": "Månedlig varmeeffektivitet",
  "reports.monthlyOutdoorReport": "Månedlig udendørsrapport",
  "reports.monthlyReport": "Månedlig rapport",
  "reports.monthlySolarReport": "Månedlig solrapport",
  "reports.monthlyWindReport": "Månedlig vindrapport",
  "reports.monthsOfData": "{months} måneders data",
  "reports.numberOfDays": "Antal dage",
  "reports.outdoorReport": "Udendørsrapport",
  "reports.overviewSection": "Oversigt",
  "reports.rainfall": "Nedbør",
  "reports.rainyDays": "Nedbørsdage",
  "reports.recordDailyRain": "Vådeste dag",
  "reports.recordHigh": "Varmerekord",
  "reports.recordLow": "Kulderekord",
  "reports.recordsAndClimatology": "Rekorder og klima",
  "reports.recordsSince": "Rekorder siden {date}",
  "reports.recordWindGust": "Stærkeste vindstød",
  "reports.relativelyWet": "Relativt vådt (60% {lessThan} luftfugtighed ≤ 80%)",
  "reports.sectionReportCount": "{count, plural, one {# rapport} other {# rapporter}}",
  "reports.sendEmail": "Send email",
  "reports.summerDays": "Sommerdage",
  "reports.tooDry": "For tørt (luftfugtighed ≤ 45%)",
  "reports.tooWet": "For vådt (luftfugtighed {greaterThan} 80%)",
  "reports.tropicalNights": "Tropenætter",
  "reports.unlockPremiumSubtitle": "Inkluderet i SmartMixin Premium",
  "reports.unlockPremiumTitle": "Lås {count, plural, one {# premiumfunktion} other {# premiumfunktioner}} op",
  "reports.warmestMonthRanking": "Varmeste {month} nogensinde målt",
  "reports.waterBalance": "Vandbalance",
  "reports.yearsOfData": "{years} års data",
  "reports.yearToDateTemperatureComparison": "Temperatursammenligning hidtil i år",
  "sensors.bgtSensors": "Sortglobe & WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareHumidity": "Sammenlign luftfugtighed",
  "sensors.compareMoisture": "Sammenlign jordfugtighed",
  "sensors.comparePm25": "Sammenlign PM2.5",
  "sensors.compareTemperatures": "Sammenlign temperaturer",
  "sensors.compareWaterTension": "Sammenlign jordvandsspænding",
  "sensors.depthByChannel": "Dybde pr. kanal",
  "sensors.heatStressExtreme": "Ekstrem varmestress",
  "sensors.heatStressModerate": "Moderat varmestress",
  "sensors.heatStressNone": "Ingen varmestress",
  "sensors.heatStressStrong": "Stærk varmestress",
  "sensors.heatStressVeryStrong": "Meget stærk varmestress",
  "sensors.indoorClimate": "Indeklima",
  "sensors.indoorCo2Levels": "CO2-niveauer",
  "sensors.indoorTemperatureAndHumidity": "Temperatur og luftfugtighed",
  "sensors.leafWetnessByChannel": "Bladfugtighed pr. kanal",
  "sensors.lightningSensor": "Lyn",
  "sensors.moistureByChannel": "Jordfugtighed pr. kanal",
  "sensors.noDataAvailable": "Ingen data tilgængelige",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 pr. kanal",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Vælg kanal",
  "sensors.sensorDetailDescription": "Se historiske data og tendenser for dine sensorkanaler.",
  "sensors.sensorHistory": "Sensorhistorik",
  "sensors.soilConductivityByChannel": "Ledningsevne pr. kanal",
  "sensors.soilTemperatureByChannel": "Jordtemperatur pr. kanal",
  "sensors.strikesToday": "Nedslag i dag",
  "sensors.temperatureByChannel": "Temperatur pr. kanal",
  "sensors.viewChart": "Vis graf",
  "sensors.waterTensionByChannel": "Jordvandsspænding pr. kanal",
  "settings.appearance": "Udseende",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "arabisk",
  "settings.bulgarian": "bulgarsk",
  "settings.catalan": "catalansk",
  "settings.chartGestures": "Gestus på diagrammer",
  "settings.chartGesturesDescription": "Strygning på diagrammer ændrer tidsperioden, klemning af diagram ændrer tidsskala",
  "settings.choiceCount": "{count, plural, one {# tilgængelig} other {# tilgængelige}}",
  "settings.contactUs": "Kontakt os",
  "settings.contactUsDescription": "Få hjælp eller send feedback",
  "settings.croatian": "kroatisk",
  "settings.czech": "tjekkisk",
  "settings.dailyDetailByPeriods": "Dagsdetaljer efter perioder",
  "settings.dailyDetailByPeriodsDescription": "Gruppér de 24 timer i nat, morgen, eftermiddag og aften — den samme opdeling som dagens opsummering bruger.",
  "settings.danish": "dansk",
  "settings.dark": "Mørkt tema",
  "settings.dataDisplay": "Datavisning",
  "settings.dateAndTime": "Dato og tid",
  "settings.donateButton": "Giv en donation",
  "settings.donateDescription": "SmartMixin er bygget af et lille team. Hvis du finder den nyttig, kan du støtte udviklingen med en engangsdonation på et hvilket som helst beløb. Det er en gave — den ændrer ikke dit abonnement og låser ikke nogen funktioner op.",
  "settings.donateSuccessBody": "Din donation hjælper med at holde SmartMixin kørende og gøre den bedre. Vi sætter stor pris på det.",
  "settings.donateSuccessTitle": "Tak for din støtte!",
  "settings.donateTitle": "Støt SmartMixin",
  "settings.dragToReorder": "Træk for at omarrangere",
  "settings.dutch": "hollandsk",
  "settings.english": "engelsk",
  "settings.french": "fransk",
  "settings.german": "tysk",
  "settings.gestures": "Gestik",
  "settings.greek": "græsk",
  "settings.hungarian": "ungarsk",
  "settings.italian": "italiensk",
  "settings.japanese": "japansk",
  "settings.korean": "koreansk",
  "settings.language": "Sprog",
  "settings.languageDescription": "Foretrukket sprog",
  "settings.light": "Lyst tema",
  "settings.measurementUnits": "Måleenheder",
  "settings.netatmoDashboard": "Netatmo-oversigt",
  "settings.netatmoLayoutCards": "Kortliste",
  "settings.netatmoLayoutCardsDescription": "Ét kort pr. modul, alt i én rulning",
  "settings.netatmoLayoutClassic": "Klassisk",
  "settings.netatmoLayoutClassicDescription": "To kort, skift mellem moduler",
  "settings.netatmoNewLayoutNotice": "Nyt layout: ét kort pr. modul.",
  "settings.netatmoSwitchBackToClassic": "Tilbage til klassisk",
  "settings.netatmoSwitchToLayout": "Skift til {layout}",
  "settings.norwegian": "norsk",
  "settings.notificationsSection": "Notifikationer",
  "settings.ongoingNotificationEnabled": "Aktiver permanent notifikation",
  "settings.ongoingNotificationMetrics": "Viste målinger",
  "settings.ongoingNotificationPermissionRequired": "Notifikationstilladelse kræves",
  "settings.ongoingNotificationPreviewHint": "Forhåndsvisning — slå widgetten til for at vise den",
  "settings.ongoingNotificationStatusBar": "Statuslinje",
  "settings.polish": "polsk",
  "settings.portuguese": "portugisisk",
  "settings.preferencesSection": "Præferencer",
  "settings.privacyPolicy": "Privatlivspolitik",
  "settings.russian": "russisk",
  "settings.serbian": "serbisk",
  "settings.settings": "Indstillinger",
  "settings.settingsPageTitle": "Indstillinger - {page}",
  "settings.slovak": "slovakisk",
  "settings.smallDecimals": "Små decimaler",
  "settings.smallDecimalsDescription": "Vis decimalcifre i en mindre størrelse",
  "settings.spanish": "spansk",
  "settings.statusBarWidget": "Statuslinje-widget",
  "settings.statusBarWidgetDescription": "Altid synlige vejrdata",
  "settings.subscriptionSection": "Abonnement",
  "settings.supportSection": "Support",
  "settings.swedish": "svensk",
  "settings.systemTheme": "Systemtema",
  "settings.termsOfService": "Servicevilkår",
  "settings.turkish": "tyrkisk",
  "settings.ukrainian": "ukrainsk",
  "settings.units": "Enheder",
  "settings.unitsDescription": "Måleenheder, der vises i applikationen",
  "settings.update": "Opdater",
  "settings.windDirectionConvention": "Vindretningspil",
  "settings.windDirectionConventionDescription": "Vælg hvordan vindretningspile vises",
  "settings.windDirectionMeteorological": "Oprindelsesretning",
  "settings.windDirectionMeteorologicalDescription": "Pilen viser hvor vinden kommer fra (meteorologisk konvention)",
  "settings.windDirectionOceanographic": "Strømningsretning",
  "settings.windDirectionOceanographicDescription": "Pilen viser hvor vinden blæser hen (oceanografisk konvention)",
  "stations.addAStation": "Tilføj en station",
  "stations.addToFavorites": "Tilføj til favoritter",
  "stations.addYourOwnStation": "Tilføj din egen station",
  "stations.clearRecentLocations": "Ryd alle",
  "stations.clearSearch": "Ryd søgning",
  "stations.currentLocation": "Nuværende placering",
  "stations.customizedStationName": "Tilpasset stationsnavn",
  "stations.favoriteLocations": "Favoritter",
  "stations.favoriteLocationsEmpty": "Du kan tilføje op til 5 yndlingssteder.",
  "stations.favoriteStations": "Favoritstationer",
  "stations.filterStationDescription": "Vis ikke stationer med upålidelige målinger",
  "stations.filterStations": "Filtrer stationer",
  "stations.filterStationSourceDescription": "Vælg stationsudbydere, som du vil have vist på kortet",
  "stations.findStationsNearYou": "Find stationer i nærheden",
  "stations.hiddenStations": "Skjulte stationer",
  "stations.hiddenStationsDescription": "Du kan vise en skjult station igen ved at trykke på øjeikonet ved siden af den.",
  "stations.lastSeen": "sidst set {time}",
  "stations.location": "Placering",
  "stations.locationAddedToFavorites": "Placering tilføjet til favoritter",
  "stations.locationNotGranted": "Placeringstilladelse tildeles ikke. Giv adgang til din placering i enhedsindstillinger.",
  "stations.locationRemovedFromFavorites": "Placering fjernet fra favoritter",
  "stations.locations": "Placeringer",
  "stations.locationUnavailable": "Kunne ikke hente din placering. Tjek indstillingerne på din enhed.",
  "stations.maxFavoriteLocationsReached": "Du kan kun have op til 5 yndlingssteder. Fjern ét for at tilføje et andet.",
  "stations.modifyFavoriteStations": "Ændre yndlingsstationer",
  "stations.modifyFavoriteStationsDescription": "Du kan ændre rækkefølgen af dine yndlingsstationer ved at trække dem. Du kan også fjerne dem fra listen.",
  "stations.myLocation": "Min placering",
  "stations.nearbyWeatherStations": "Nærliggende vejrstationer",
  "stations.noLocationsFound": "Ingen steder fundet",
  "stations.noSearchResults": "Ingen artikler matcher din søgning",
  "stations.noStationsFound": "Ingen stationer fundet",
  "stations.noWeatherStationYet": "Du har ikke en vejrstation endnu.",
  "stations.recentLocations": "Seneste",
  "stations.recentLocationsEmpty": "Din historik er tom.",
  "stations.removeFromFavorites": "Fjern fra favoritter",
  "stations.searchForLocation": "Søg efter en beliggenhed",
  "stations.searchForWeatherStation": "Søg efter en vejrstation",
  "stations.searchResults": "Søgeresultater",
  "stations.searchResultsEmpty": "Ingen resultater fundet.",
  "stations.searchResultsFound": "{count, plural, one {# resultat fundet} other {# resultater fundet}}",
  "stations.searchStationsDescription": "Indtast en by, adresse eller stednavn for at finde vejrstationer i nærheden.",
  "stations.searchStationsHint": "Brug søgefeltet ovenfor til at opdage vejrstationer hvor som helst i verden.",
  "stations.selectStationForComparison": "Vælg en vejrstation at sammenligne med",
  "stations.stationAddedToFavorites": "Station tilføjet til favoritter",
  "stations.stationCount": "{count, plural, one {# station} other {# stationer}}",
  "stations.stationInformation": "Stationsinformation",
  "stations.stationName": "Stationsnavn",
  "stations.stationObservationsDescription": "Vis de seneste observationer fra vejrstationer",
  "stations.stationRemovedFromFavorites": "Station fjernet fra favoritter",
  "stations.stationsNear": "Stationer nær {place}",
  "stations.stationType": "Stationstype",
  "stations.statusOffline": "Offline",
  "stations.statusOnline": "Online",
  "stations.statusStale": "Forældet",
  "stations.tryAnotherLocation": "Vi kunne ikke finde vejrstationer i nærheden af denne placering. Prøv at søge i et andet område.",
  "stations.weatherStation": "Vejrstation",
  "stations.weatherStationCount": "{count, plural, one {# vejrstation} other {# vejrstationer}}",
  "stations.weatherStations": "Vejrstationer",
  "stations.welcomeConnectService": "Ejer du en vejrstation? Tilslut din tjeneste",
  "stations.welcomeSubtitle": "Dit vejr, samlet ét sted",
  "thermostat.away": "Væk",
  "thermostat.boilerOn": "Kedel tændt",
  "thermostat.hg": "Frostsikring",
  "thermostat.homeInformation": "Hjemmeoplysninger",
  "thermostat.homeName": "Hjemmenavn",
  "thermostat.manualBoost": "Manuel boost",
  "thermostat.manualSetpointUntil": "Manuel sætpunkt indtil",
  "thermostat.noThermostatYet": "Du har ikke en termostat endnu.",
  "thermostat.relay": "Styringsenhed",
  "thermostat.room": "Værelse",
  "thermostat.rooms": "Værelser",
  "thermostat.smartThermostat": "Smart termostat",
  "thermostat.smartValve": "Smart ventil",
  "thermostat.whenBackHome": "Hvornår vil du være hjemme igen?",
  "units.celsius": "Celsius",
  "units.fahrenheit": "Fahrenheit",
  "units.inch": "Tommer",
  "units.inchOfMercury": "Tommer kviksølv",
  "units.kelvin": "Kelvin",
  "units.kilometerPerHour": "Kilometer i timen",
  "units.knot": "Knob",
  "units.meterPerSecond": "Meter pr. sekund",
  "units.milePerHour": "Miles i timen",
  "units.millibar": "Millibar",
  "units.millimeter": "Millimeter",
  "units.millimeterOfMercury": "Millimeter kviksølv",
  "weatherConditions.blizzard": "Snestorm",
  "weatherConditions.blowingDust": "Fygende støv",
  "weatherConditions.blowingSnow": "Fygende sne",
  "weatherConditions.breezy": "Let blæst",
  "weatherConditions.clear": "Klart",
  "weatherConditions.cloudy": "Overskyet",
  "weatherConditions.drizzle": "Finregn",
  "weatherConditions.flurries": "Lette snebyger",
  "weatherConditions.foggy": "Tåge",
  "weatherConditions.freezingDrizzle": "Underafkølet finregn",
  "weatherConditions.freezingRain": "Underafkølet regn",
  "weatherConditions.frigid": "Bidende kulde",
  "weatherConditions.hail": "Hagl",
  "weatherConditions.haze": "Dis",
  "weatherConditions.heavyRain": "Kraftig regn",
  "weatherConditions.heavySnow": "Kraftigt snefald",
  "weatherConditions.hot": "Varmt",
  "weatherConditions.hurricane": "Orkan",
  "weatherConditions.isolatedThunderstorms": "Enkelte tordenbyger",
  "weatherConditions.mixedRainAndHail": "Regn og hagl",
  "weatherConditions.mostlyClear": "Overvejende klart",
  "weatherConditions.mostlyCloudy": "Overvejende skyet",
  "weatherConditions.mostlySunny": "Overvejende solrigt",
  "weatherConditions.notAvailable": "Vejrforhold ikke tilgængelige",
  "weatherConditions.partlyCloudy": "Delvist skyet",
  "weatherConditions.rain": "Regn",
  "weatherConditions.rainSleet": "Regn og iskorn",
  "weatherConditions.rainSnow": "Regn og sne",
  "weatherConditions.scatteredShowers": "Spredte byger",
  "weatherConditions.scatteredSnowShowers": "Spredte snebyger",
  "weatherConditions.scatteredThunderstorms": "Spredte tordenbyger",
  "weatherConditions.showers": "Byger",
  "weatherConditions.sleet": "Iskorn",
  "weatherConditions.smoke": "Røg",
  "weatherConditions.snow": "Sne",
  "weatherConditions.snowShowers": "Snebyger",
  "weatherConditions.strongStorms": "Kraftige tordenbyger",
  "weatherConditions.sunny": "Solrigt",
  "weatherConditions.thunderstorms": "Tordenbyger",
  "weatherConditions.tornado": "Tornado",
  "weatherConditions.tropicalStorm": "Tropisk storm",
  "weatherConditions.windy": "Blæsende",
  "weatherConditions.wintryMix": "Blandet vinternedbør",
  "weatherMap.legendHeavy": "Kraftig",
  "weatherMap.legendLight": "Let",
  "weatherMap.legendLightningHelp": "Farven viser hvert lynnedslags alder over de seneste {minutes} minutter — nyeste i hvidt, ældste i mørkerødt.",
  "weatherMap.legendNewest": "Nyeste",
  "weatherMap.legendOldest": "Ældste",
  "weatherMap.legendStationsHelp": "Markørens farve afspejler værdien af den valgte måling.",
  "weatherMap.lightningDataAttribution": "Lyndata: Blitzortung.org",
  "weatherMap.lightningStrikes": "Lynnedslag",
  "weatherMap.lightningStrikesDescription": "Vis lynnedslag i realtid på kortet",
  "weatherMap.mapLayers": "Kortlag",
  "weatherMap.mapLegend": "Kortsignatur",
  "weatherMap.radarDataAttribution": "Radardata: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.rainRadar": "Regnradar",
  "weatherMap.rainRadarDescription": "Vis regnradaroverlejring på kortet",
  "weatherMap.weatherflowNCRain": "NC rain (Nearcast rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain er en ekstra datakilde leveret via Tempest Weather System, drevet af Nearcast Technology. NC Rain-data er et estimat af den gennemsnitlige nedbørsmængde omkring din Tempest på kvartersniveau",
  "weatherMap.weatherMap": "Vejrkort",
  "weatherMap.weatherMapMetaDescription": "SmartMixin tilbyder interaktive vejr- og radarkort for vejrforhold verden over.",
  "weatherWarnings.activeNow": "Aktive nu",
  "weatherWarnings.agencyMessage": "Meddelelse fra vejrtjenesten",
  "weatherWarnings.areaCovered": "Berørt område",
  "weatherWarnings.areaThisLocation": "{area} (dette sted)",
  "weatherWarnings.areaYourStation": "{area} (din vejrstation)",
  "weatherWarnings.crumb": "Officielle varsler",
  "weatherWarnings.emptyBody": "Den nationale vejrtjeneste har intet varsel i kraft for dette sted. Vi tjekker igen med få minutters mellemrum.",
  "weatherWarnings.emptyTitle": "Ingen officielle varsler",
  "weatherWarnings.ended": "Udløbet",
  "weatherWarnings.endedAt": "Dette varsel udløb {time}.",
  "weatherWarnings.errorBody": "Tjek din forbindelse. Vi prøver igen med få minutters mellemrum.",
  "weatherWarnings.errorTitle": "Kunne ikke indlæse officielle varsler",
  "weatherWarnings.fromTime": "Fra {time}",
  "weatherWarnings.hazardAirQuality": "Luftkvalitet",
  "weatherWarnings.hazardAvalanche": "Laviner",
  "weatherWarnings.hazardCoastalEvent": "Kystfarer",
  "weatherWarnings.hazardFlood": "Oversvømmelser",
  "weatherWarnings.hazardFog": "Tåge",
  "weatherWarnings.hazardForestFire": "Skovbrande",
  "weatherWarnings.hazardHighTemperature": "Høje temperaturer",
  "weatherWarnings.hazardLowTemperature": "Lave temperaturer",
  "weatherWarnings.hazardOther": "Anden fare",
  "weatherWarnings.hazardRain": "Regn",
  "weatherWarnings.hazardSnowIce": "Sne og is",
  "weatherWarnings.hazardThunderstorm": "Tordenbyger",
  "weatherWarnings.hazardUv": "UV-stråling",
  "weatherWarnings.hazardWind": "Vind",
  "weatherWarnings.hideHazards": "Skjul farer",
  "weatherWarnings.issuedBy": "Udsendt af {sender}",
  "weatherWarnings.lastUpdate": "Senest opdateret: {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {Kort over det berørte område: {area}.} other {Kort over de # berørte områder. {area} er fremhævet.}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {Kortet er ikke tilgængeligt. Området er vist nedenfor.} other {Kortet er ikke tilgængeligt. De # områder er vist nedenfor.}}",
  "weatherWarnings.moreHazards": "+ {count} mere: {hazards}",
  "weatherWarnings.notInLanguage": "Ikke tilgængelig på {language}. Vist, som vejrtjenesten har udgivet den.",
  "weatherWarnings.openOn": "Åbn på {site}",
  "weatherWarnings.otherAreas": "{count, plural, one {+ # andet område} other {+ # andre områder}}",
  "weatherWarnings.severityExtreme": "Ekstrem",
  "weatherWarnings.severityFrom": "{severity} fra {time}",
  "weatherWarnings.severityMinor": "Mindre",
  "weatherWarnings.severityModerate": "Moderat",
  "weatherWarnings.severityNow": "{severity} nu",
  "weatherWarnings.severitySevere": "Alvorlig",
  "weatherWarnings.severityUntil": "{severity} indtil {time}",
  "weatherWarnings.showAllAreas": "{count, plural, one {Vis # område} other {Vis alle # områder}}",
  "weatherWarnings.showHazards": "Vis farer",
  "weatherWarnings.showPeriods": "{count, plural, one {Vis # periode} other {Vis alle # perioder}}",
  "weatherWarnings.source": "Kilde: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, derefter {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# officielt vejrvarsel} other {# officielle vejrvarsler}}. {hazards}",
  "weatherWarnings.spokenLabelArea": "{label} {area}.",
  "weatherWarnings.spokenPeriod": "{severity}: {range}",
  "weatherWarnings.title": "Officielle vejrvarsler",
  "weatherWarnings.todayAt": "i dag kl. {time}",
  "weatherWarnings.tomorrow": "I morgen",
  "weatherWarnings.tomorrowAt": "i morgen kl. {time}",
  "weatherWarnings.upcoming": "Kommende",
  "weatherWarnings.viewAll": "Alle officielle varsler",
  "weatherWarnings.whatToDo": "Det skal du gøre"
}
